var render = function render(){
  var _vm$user99, _vm$user100, _vm$user146, _vm$user147, _vm$conditeDetail, _vm$conditeDetail2, _vm$conditeDetail3, _vm$conditeDetail4, _vm$conditeDetail5, _vm$conditeDetail6, _vm$conditeDetail7, _vm$conditeDetail8, _vm$options_reason_si, _vm$options_reason_si2, _vm$options_reason_si3, _vm$options_reason_si4, _vm$options_reason_si5, _vm$options_reason_si6;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "my-page"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "pdf-exclude"
  }, [_c('b-button', {
    staticClass: "d-inline-block",
    attrs: {
      "variant": "primary",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _c('span', [_vm._v("Kembali")])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-user-profile-block1"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$user, _vm$user2, _vm$user3, _vm$user3$personal_da, _vm$user4, _vm$user4$personal_da, _vm$user$personal_dat, _vm$user5, _vm$user5$personal_da, _vm$user6, _vm$user6$status_emp_, _vm$user7, _vm$user7$status_emp_, _vm$user8, _vm$user8$status_emp_, _vm$user9, _vm$user9$status_emp_, _vm$user$status_emp_c, _vm$user10, _vm$user10$status_emp, _vm$user$personal_dat2, _vm$user11, _vm$user11$personal_d, _vm$user$company$comp, _vm$user12, _vm$user12$company, _vm$user$position$nam, _vm$user13, _vm$user13$position, _vm$user$vehicle$name, _vm$user14, _vm$user14$vehicle, _vm$user$personal_dat3, _vm$user15, _vm$user15$personal_d, _vm$user$status_hire, _vm$user16, _vm$moment$format, _vm$user17, _vm$user18, _vm$user18$status_emp, _vm$user19, _vm$user19$status_emp, _vm$user20, _vm$user20$status_emp, _vm$user21, _vm$user22, _vm$user23, _vm$user24, _vm$user25, _vm$user26, _vm$user27, _vm$user28, _vm$user28$reason_sig, _vm$user29, _vm$user$nip, _vm$user30, _vm$user$personal_dat4, _vm$user31, _vm$user31$personal_d, _vm$user$personal_dat5, _vm$user32, _vm$user32$personal_d, _vm$user$personal_dat6, _vm$user33, _vm$user33$personal_d, _vm$user$personal_dat7, _vm$user34, _vm$user34$personal_d, _vm$user$personal_dat8, _vm$user35, _vm$user35$personal_d, _vm$user$personal_dat9, _vm$user36, _vm$user36$personal_d, _vm$user$personal_dat10, _vm$user37, _vm$user37$personal_d, _vm$user$personal_dat11, _vm$user38, _vm$user38$personal_d, _vm$user$personal_dat12, _vm$user39, _vm$user39$personal_d, _vm$user$company$comp2, _vm$user40, _vm$user40$company, _vm$user$personal_dat13, _vm$user41, _vm$user41$personal_d, _vm$user41$personal_d2, _vm$user$vehicle$name2, _vm$user42, _vm$user42$vehicle, _vm$user$personal_dat14, _vm$user43, _vm$user43$personal_d, _vm$user$personal_dat15, _vm$user44, _vm$user44$personal_d, _vm$user$personal_dat16, _vm$user45, _vm$user45$personal_d, _vm$user46, _vm$user46$personal_d, _vm$user46$personal_d2, _vm$user47, _vm$user47$personal_d, _vm$user47$personal_d2, _vm$user48, _vm$user48$personal_d, _vm$user48$personal_d2, _vm$user$personal_dat17, _vm$user49, _vm$user49$personal_d, _vm$user$personal_dat18, _vm$user50, _vm$user50$personal_d, _vm$user51, _vm$user51$alamat_ktp, _vm$user51$alamat_ktp2, _vm$user52, _vm$user52$alamat_ktp, _vm$user52$alamat_ktp2, _vm$user53, _vm$user53$alamat_ktp, _vm$user53$alamat_ktp2, _vm$user54, _vm$user54$alamat_ktp, _vm$user54$alamat_ktp2, _vm$user55, _vm$user55$alamat_ktp, _vm$user55$alamat_ktp2, _vm$user56, _vm$user56$alamat_ktp, _vm$user56$alamat_ktp2, _vm$user57, _vm$user57$alamat_ktp, _vm$user57$alamat_ktp2, _vm$user58, _vm$user58$address, _vm$user58$address$, _vm$user59, _vm$user59$address, _vm$user59$address$, _vm$user60, _vm$user60$address, _vm$user60$address$, _vm$user61, _vm$user61$address, _vm$user61$address$, _vm$user62, _vm$user62$address, _vm$user62$address$, _vm$user63, _vm$user63$address, _vm$user63$address$, _vm$user64, _vm$user64$address, _vm$user64$address$, _vm$user65, _vm$user65$alamat_dom, _vm$user65$alamat_dom2, _vm$user66, _vm$user66$alamat_dom, _vm$user66$alamat_dom2, _vm$user67, _vm$user67$alamat_dom, _vm$user67$alamat_dom2, _vm$user68, _vm$user68$alamat_dom, _vm$user68$alamat_dom2, _vm$user69, _vm$user69$alamat_dom, _vm$user69$alamat_dom2, _vm$user70, _vm$user70$alamat_dom, _vm$user70$alamat_dom2, _vm$user71, _vm$user71$alamat_dom, _vm$user71$alamat_dom2, _vm$user72, _vm$user72$address, _vm$user72$address$, _vm$user73, _vm$user73$address, _vm$user73$address$, _vm$user74, _vm$user74$address, _vm$user74$address$, _vm$user75, _vm$user75$address, _vm$user75$address$, _vm$user76, _vm$user76$address, _vm$user76$address$, _vm$user77, _vm$user77$address, _vm$user77$address$, _vm$user78, _vm$user78$address, _vm$user78$address$;
        return [_c('div', {
          staticClass: "user-details-block"
        }, [_c('div', {
          staticClass: "user-profile text-center"
        }, [_vm.$route.query.user === 'crew' ? _c('img', {
          staticClass: "avatar-130 img-fluid",
          attrs: {
            "src": (_vm$user = _vm.user) !== null && _vm$user !== void 0 && _vm$user.photo ? (_vm$user2 = _vm.user) === null || _vm$user2 === void 0 ? void 0 : _vm$user2.photo_url : _vm.default_photo,
            "alt": "profile-img"
          }
        }) : _c('img', {
          staticClass: "avatar-130 img-fluid",
          attrs: {
            "src": (_vm$user3 = _vm.user) !== null && _vm$user3 !== void 0 && (_vm$user3$personal_da = _vm$user3.personal_data) !== null && _vm$user3$personal_da !== void 0 && _vm$user3$personal_da.photo ? (_vm$user4 = _vm.user) === null || _vm$user4 === void 0 ? void 0 : (_vm$user4$personal_da = _vm$user4.personal_data) === null || _vm$user4$personal_da === void 0 ? void 0 : _vm$user4$personal_da.photo_url : _vm.default_photo,
            "alt": "profile-img"
          }
        })]), _vm.$route.query.user === 'candidate' ? _c('div', {
          staticClass: "text-center mt-3"
        }, [_c('h4', [_c('b', [_vm._v(_vm._s((_vm$user$personal_dat = (_vm$user5 = _vm.user) === null || _vm$user5 === void 0 ? void 0 : (_vm$user5$personal_da = _vm$user5.personal_data) === null || _vm$user5$personal_da === void 0 ? void 0 : _vm$user5$personal_da.full_name) !== null && _vm$user$personal_dat !== void 0 ? _vm$user$personal_dat : '-'))])])]) : _vm._e(), _vm.$route.query.user === 'crew' ? _c('div', {
          staticStyle: {
            "position": "absolute",
            "top": "0",
            "right": "0"
          },
          on: {
            "click": function click($event) {
              return _vm.openModalSwapPosition(true);
            }
          }
        }, [((_vm$user6 = _vm.user) === null || _vm$user6 === void 0 ? void 0 : (_vm$user6$status_emp_ = _vm$user6.status_emp_crewing) === null || _vm$user6$status_emp_ === void 0 ? void 0 : _vm$user6$status_emp_.alias) !== 'finish' && ((_vm$user7 = _vm.user) === null || _vm$user7 === void 0 ? void 0 : (_vm$user7$status_emp_ = _vm$user7.status_emp_crewing) === null || _vm$user7$status_emp_ === void 0 ? void 0 : _vm$user7$status_emp_.alias) !== 'unfinish' && ((_vm$user8 = _vm.user) === null || _vm$user8 === void 0 ? void 0 : (_vm$user8$status_emp_ = _vm$user8.status_emp_crewing) === null || _vm$user8$status_emp_ === void 0 ? void 0 : _vm$user8$status_emp_.alias) !== 'blacklist' ? _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.swap-position",
            modifiers: {
              "swap-position": true
            }
          }],
          staticClass: "d-inline-block",
          attrs: {
            "variant": "warning",
            "type": "button"
          }
        }, [_c('span', [_vm._v("Swap Position")])]) : _vm._e()], 1) : _vm._e(), _vm.$route.query.user === 'crew' ? _c('div', {
          staticClass: "text-center mt-3"
        }, [_c('b', {
          class: ((_vm$user9 = _vm.user) === null || _vm$user9 === void 0 ? void 0 : (_vm$user9$status_emp_ = _vm$user9.status_emp_crewing) === null || _vm$user9$status_emp_ === void 0 ? void 0 : _vm$user9$status_emp_.alias) === 'active' ? 'text-success' : 'text-warning'
        }, [_vm._v(_vm._s((_vm$user$status_emp_c = (_vm$user10 = _vm.user) === null || _vm$user10 === void 0 ? void 0 : (_vm$user10$status_emp = _vm$user10.status_emp_crewing) === null || _vm$user10$status_emp === void 0 ? void 0 : _vm$user10$status_emp.name) !== null && _vm$user$status_emp_c !== void 0 ? _vm$user$status_emp_c : '-'))])]) : _vm._e(), _vm.$route.query.user === 'crew' ? _c('div', {
          staticClass: "text-center"
        }, [_c('h4', [_c('b', [_vm._v(_vm._s((_vm$user$personal_dat2 = (_vm$user11 = _vm.user) === null || _vm$user11 === void 0 ? void 0 : (_vm$user11$personal_d = _vm$user11.personal_data) === null || _vm$user11$personal_d === void 0 ? void 0 : _vm$user11$personal_d.full_name) !== null && _vm$user$personal_dat2 !== void 0 ? _vm$user$personal_dat2 : '-'))])]), _c('strong', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s((_vm$user$company$comp = (_vm$user12 = _vm.user) === null || _vm$user12 === void 0 ? void 0 : (_vm$user12$company = _vm$user12.company) === null || _vm$user12$company === void 0 ? void 0 : _vm$user12$company.company) !== null && _vm$user$company$comp !== void 0 ? _vm$user$company$comp : '-'))]), _c('br'), _c('strong', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s((_vm$user$position$nam = (_vm$user13 = _vm.user) === null || _vm$user13 === void 0 ? void 0 : (_vm$user13$position = _vm$user13.position) === null || _vm$user13$position === void 0 ? void 0 : _vm$user13$position.name) !== null && _vm$user$position$nam !== void 0 ? _vm$user$position$nam : '-'))]), _c('br'), _c('strong', [_vm._v("(" + _vm._s((_vm$user$vehicle$name = (_vm$user14 = _vm.user) === null || _vm$user14 === void 0 ? void 0 : (_vm$user14$vehicle = _vm$user14.vehicle) === null || _vm$user14$vehicle === void 0 ? void 0 : _vm$user14$vehicle.name) !== null && _vm$user$vehicle$name !== void 0 ? _vm$user$vehicle$name : '-') + ")")]), _c('p', [_vm._v(" " + _vm._s(_vm.countAge) + " Tahun, " + _vm._s((_vm$user$personal_dat3 = (_vm$user15 = _vm.user) === null || _vm$user15 === void 0 ? void 0 : (_vm$user15$personal_d = _vm$user15.personal_data) === null || _vm$user15$personal_d === void 0 ? void 0 : _vm$user15$personal_d.place_of_birth) !== null && _vm$user$personal_dat3 !== void 0 ? _vm$user$personal_dat3 : '-') + " "), _c('br'), _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s((_vm$user$status_hire = (_vm$user16 = _vm.user) === null || _vm$user16 === void 0 ? void 0 : _vm$user16.status_hire) !== null && _vm$user$status_hire !== void 0 ? _vm$user$status_hire : '-') + ", " + _vm._s((_vm$moment$format = _vm.moment(new Date((_vm$user17 = _vm.user) === null || _vm$user17 === void 0 ? void 0 : _vm$user17.created_at)).format('DD MMMM YYYY')) !== null && _vm$moment$format !== void 0 ? _vm$moment$format : '-'))])], 1)]) : _vm._e()]), _c('div', {
          staticClass: "mb-4 pdf-exclude"
        }, [_c('b-button', {
          attrs: {
            "variant": "primary",
            "block": "",
            "type": "button",
            "className": "mb-1"
          },
          on: {
            "click": function click($event) {
              return _vm.$router.push({
                path: '/crewing/profile-edit',
                query: {
                  user: _vm.$route.query.user,
                  id: _vm.$route.query.id
                }
              });
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _c('span', [_vm._v("Edit Profile")])]), ((_vm$user18 = _vm.user) === null || _vm$user18 === void 0 ? void 0 : (_vm$user18$status_emp = _vm$user18.status_emp_crewing) === null || _vm$user18$status_emp === void 0 ? void 0 : _vm$user18$status_emp.alias) !== 'finish' && ((_vm$user19 = _vm.user) === null || _vm$user19 === void 0 ? void 0 : (_vm$user19$status_emp = _vm$user19.status_emp_crewing) === null || _vm$user19$status_emp === void 0 ? void 0 : _vm$user19$status_emp.alias) !== 'unfinish' && ((_vm$user20 = _vm.user) === null || _vm$user20 === void 0 ? void 0 : (_vm$user20$status_emp = _vm$user20.status_emp_crewing) === null || _vm$user20$status_emp === void 0 ? void 0 : _vm$user20$status_emp.alias) !== 'blacklist' ? _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.request-signoff",
            modifiers: {
              "request-signoff": true
            }
          }],
          attrs: {
            "variant": "warning",
            "block": "",
            "type": "button"
          }
        }, [_c('span', [_vm._v("Request Sign Off")])]) : _vm._e()], 1), _vm.$route.query.user === 'crew' ? _c('b-alert', {
          staticClass: "text-center text-white bg-primary",
          attrs: {
            "show": true
          }
        }, [_c('div', {
          staticClass: "iq-alert-text d-flex w-100 align-items-center justify-content-between"
        }, [_c('i', {
          staticClass: "fa fa-check",
          staticStyle: {
            "opacity": "0"
          }
        }), _c('strong', [_vm._v("JOIN DATE")]), !_vm.isEditJoinDate ? _c('i', {
          staticClass: "fa fa-pen",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function click($event) {
              _vm.isEditJoinDate = !_vm.isEditJoinDate;
            }
          }
        }) : _c('i', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function click($event) {
              _vm.isEditJoinDate = !_vm.isEditJoinDate;
            }
          }
        })])]) : _vm._e(), _vm.$route.query.user === 'crew' ? _c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Sign On")])]), _c('td', [_vm.isEditJoinDate && _vm.user.sign_on ? _c('b-form-input', {
          attrs: {
            "id": "sign_on",
            "name": "sign_on",
            "type": "datetime-local"
          },
          model: {
            value: _vm.formJoinDate.sign_on,
            callback: function callback($$v) {
              _vm.$set(_vm.formJoinDate, "sign_on", $$v);
            },
            expression: "formJoinDate.sign_on"
          }
        }) : _c('span', [_vm._v(_vm._s((_vm$user21 = _vm.user) !== null && _vm$user21 !== void 0 && _vm$user21.sign_on ? _vm.moment(new Date((_vm$user22 = _vm.user) === null || _vm$user22 === void 0 ? void 0 : _vm$user22.sign_on)).format('DD MMMM YYYY HH:mm') : "-"))])], 1)]), _c('tr', [_c('td', [_c('strong', [_vm._v("Join On Board")])]), _c('td', [_vm.isEditJoinDate && _vm.user.join_on_board ? _c('b-form-input', {
          attrs: {
            "id": "join_on_board",
            "name": "join_on_board",
            "type": "datetime-local"
          },
          model: {
            value: _vm.formJoinDate.join_on_board,
            callback: function callback($$v) {
              _vm.$set(_vm.formJoinDate, "join_on_board", $$v);
            },
            expression: "formJoinDate.join_on_board"
          }
        }) : _c('span', [_vm._v(_vm._s((_vm$user23 = _vm.user) !== null && _vm$user23 !== void 0 && _vm$user23.join_on_board ? _vm.moment(new Date((_vm$user24 = _vm.user) === null || _vm$user24 === void 0 ? void 0 : _vm$user24.join_on_board)).format('DD MMMM YYYY HH:mm') : '-'))])], 1)]), _c('tr', [_c('td', [_c('strong', [_vm._v("Sign Off")])]), _c('td', [_vm.isEditJoinDate && _vm.user.sign_off ? _c('b-form-input', {
          attrs: {
            "id": "sign_off",
            "name": "sign_off",
            "type": "datetime-local",
            "disabled": !((_vm$user25 = _vm.user) !== null && _vm$user25 !== void 0 && _vm$user25.sign_off)
          },
          model: {
            value: _vm.formJoinDate.sign_off,
            callback: function callback($$v) {
              _vm.$set(_vm.formJoinDate, "sign_off", $$v);
            },
            expression: "formJoinDate.sign_off"
          }
        }) : _c('span', [_vm._v(_vm._s((_vm$user26 = _vm.user) !== null && _vm$user26 !== void 0 && _vm$user26.sign_off ? _vm.moment(new Date((_vm$user27 = _vm.user) === null || _vm$user27 === void 0 ? void 0 : _vm$user27.sign_off)).format('DD MMMM YYYY HH:mm') : '-'))])], 1)]), ((_vm$user28 = _vm.user) === null || _vm$user28 === void 0 ? void 0 : (_vm$user28$reason_sig = _vm$user28.reason_sign_off_list) === null || _vm$user28$reason_sig === void 0 ? void 0 : _vm$user28$reason_sig.length) > 0 ? _c('tr', [_c('td', [_c('strong', [_vm._v("Reason")])]), _c('td', {
          staticClass: "text-start"
        }, [_c('div', {
          staticClass: "gap-1"
        }, _vm._l((_vm$user29 = _vm.user) === null || _vm$user29 === void 0 ? void 0 : _vm$user29.reason_sign_off_list, function (obj, index) {
          return _c('div', {
            key: index + 'signoff-list'
          }, [_c('strong', [_vm._v(">")]), _vm._v(_vm._s(" ") + " "), _c('span', [_vm._v(_vm._s(obj.name))]), _vm._v(" "), _c('br')]);
        }), 0)])]) : _vm._e(), _vm.isEditJoinDate ? _c('tr', [_c('td', {
          staticClass: "text-right",
          attrs: {
            "colspan": "2"
          }
        }, [_c('b-button', {
          attrs: {
            "type": "button",
            "variant": "primary"
          },
          on: {
            "click": _vm.onEditJoinDate
          }
        }, [_c('i', {
          staticClass: "fa fa-pen mr-1"
        }), _vm._v(" Edit Join Date")])], 1)]) : _vm._e()])]) : _vm._e(), _c('b-alert', {
          staticClass: "text-center text-white bg-primary",
          attrs: {
            "show": true
          }
        }, [_c('div', {
          staticClass: "iq-alert-text"
        }, [_c('strong', [_vm._v("DATA DIRI")])])]), _c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_vm.$route.query.user === 'crew' ? _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor Pegawai")])]), _c('td', [_vm._v(_vm._s((_vm$user$nip = (_vm$user30 = _vm.user) === null || _vm$user30 === void 0 ? void 0 : _vm$user30.nip) !== null && _vm$user$nip !== void 0 ? _vm$user$nip : '-'))])]) : _vm._e(), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor KTP")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat4 = (_vm$user31 = _vm.user) === null || _vm$user31 === void 0 ? void 0 : (_vm$user31$personal_d = _vm$user31.personal_data) === null || _vm$user31$personal_d === void 0 ? void 0 : _vm$user31$personal_d.nik_ktp) !== null && _vm$user$personal_dat4 !== void 0 ? _vm$user$personal_dat4 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor KK")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat5 = (_vm$user32 = _vm.user) === null || _vm$user32 === void 0 ? void 0 : (_vm$user32$personal_d = _vm$user32.personal_data) === null || _vm$user32$personal_d === void 0 ? void 0 : _vm$user32$personal_d.no_kk) !== null && _vm$user$personal_dat5 !== void 0 ? _vm$user$personal_dat5 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Jenis Kelamin")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat6 = (_vm$user33 = _vm.user) === null || _vm$user33 === void 0 ? void 0 : (_vm$user33$personal_d = _vm$user33.personal_data) === null || _vm$user33$personal_d === void 0 ? void 0 : _vm$user33$personal_d.gender) !== null && _vm$user$personal_dat6 !== void 0 ? _vm$user$personal_dat6 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Seaferer Code")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat7 = (_vm$user34 = _vm.user) === null || _vm$user34 === void 0 ? void 0 : (_vm$user34$personal_d = _vm$user34.personal_data) === null || _vm$user34$personal_d === void 0 ? void 0 : _vm$user34$personal_d.seaferer_code) !== null && _vm$user$personal_dat7 !== void 0 ? _vm$user$personal_dat7 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor NPWP")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat8 = (_vm$user35 = _vm.user) === null || _vm$user35 === void 0 ? void 0 : (_vm$user35$personal_d = _vm$user35.personal_data) === null || _vm$user35$personal_d === void 0 ? void 0 : _vm$user35$personal_d.npwp_number) !== null && _vm$user$personal_dat8 !== void 0 ? _vm$user$personal_dat8 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor BPJS Kesehatan")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat9 = (_vm$user36 = _vm.user) === null || _vm$user36 === void 0 ? void 0 : (_vm$user36$personal_d = _vm$user36.personal_data) === null || _vm$user36$personal_d === void 0 ? void 0 : _vm$user36$personal_d.bpjs_kes_number) !== null && _vm$user$personal_dat9 !== void 0 ? _vm$user$personal_dat9 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor Seamanbook")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat10 = (_vm$user37 = _vm.user) === null || _vm$user37 === void 0 ? void 0 : (_vm$user37$personal_d = _vm$user37.personal_data) === null || _vm$user37$personal_d === void 0 ? void 0 : _vm$user37$personal_d.seaman_book_number) !== null && _vm$user$personal_dat10 !== void 0 ? _vm$user$personal_dat10 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor Passport")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat11 = (_vm$user38 = _vm.user) === null || _vm$user38 === void 0 ? void 0 : (_vm$user38$personal_d = _vm$user38.personal_data) === null || _vm$user38$personal_d === void 0 ? void 0 : _vm$user38$personal_d.passport_number) !== null && _vm$user$personal_dat11 !== void 0 ? _vm$user$personal_dat11 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor BPJS Ketenagakerjaan")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat12 = (_vm$user39 = _vm.user) === null || _vm$user39 === void 0 ? void 0 : (_vm$user39$personal_d = _vm$user39.personal_data) === null || _vm$user39$personal_d === void 0 ? void 0 : _vm$user39$personal_d.bpjs_tk_number) !== null && _vm$user$personal_dat12 !== void 0 ? _vm$user$personal_dat12 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Perusaahaan")])]), _c('td', [_vm._v(_vm._s((_vm$user$company$comp2 = (_vm$user40 = _vm.user) === null || _vm$user40 === void 0 ? void 0 : (_vm$user40$company = _vm$user40.company) === null || _vm$user40$company === void 0 ? void 0 : _vm$user40$company.company) !== null && _vm$user$company$comp2 !== void 0 ? _vm$user$company$comp2 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Jabatan/Ijazah")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat13 = (_vm$user41 = _vm.user) === null || _vm$user41 === void 0 ? void 0 : (_vm$user41$personal_d = _vm$user41.personal_data) === null || _vm$user41$personal_d === void 0 ? void 0 : (_vm$user41$personal_d2 = _vm$user41$personal_d.position) === null || _vm$user41$personal_d2 === void 0 ? void 0 : _vm$user41$personal_d2.name) !== null && _vm$user$personal_dat13 !== void 0 ? _vm$user$personal_dat13 : '-'))])]), _vm.$route.query.user === 'crew' ? _c('tr', [_c('td', [_c('strong', [_vm._v("Kapal/Fleet")])]), _c('td', [_vm._v(_vm._s((_vm$user$vehicle$name2 = (_vm$user42 = _vm.user) === null || _vm$user42 === void 0 ? void 0 : (_vm$user42$vehicle = _vm$user42.vehicle) === null || _vm$user42$vehicle === void 0 ? void 0 : _vm$user42$vehicle.name) !== null && _vm$user$vehicle$name2 !== void 0 ? _vm$user$vehicle$name2 : '-'))])]) : _vm._e(), _c('tr', [_c('td', [_c('strong', [_vm._v("Kewarganegaraan")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat14 = (_vm$user43 = _vm.user) === null || _vm$user43 === void 0 ? void 0 : (_vm$user43$personal_d = _vm$user43.personal_data) === null || _vm$user43$personal_d === void 0 ? void 0 : _vm$user43$personal_d.citizenship) !== null && _vm$user$personal_dat14 !== void 0 ? _vm$user$personal_dat14 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Tempat/Tanggal Lahir")])]), _c('td', [_vm._v(" " + _vm._s((_vm$user$personal_dat15 = (_vm$user44 = _vm.user) === null || _vm$user44 === void 0 ? void 0 : (_vm$user44$personal_d = _vm$user44.personal_data) === null || _vm$user44$personal_d === void 0 ? void 0 : _vm$user44$personal_d.place_of_birth) !== null && _vm$user$personal_dat15 !== void 0 ? _vm$user$personal_dat15 : '-') + " /  " + _vm._s((_vm$user$personal_dat16 = (_vm$user45 = _vm.user) === null || _vm$user45 === void 0 ? void 0 : (_vm$user45$personal_d = _vm$user45.personal_data) === null || _vm$user45$personal_d === void 0 ? void 0 : _vm$user45$personal_d.date_of_birth) !== null && _vm$user$personal_dat16 !== void 0 ? _vm$user$personal_dat16 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Golongan Darah")])]), _c('td', [_vm._v(_vm._s((_vm$user46 = _vm.user) === null || _vm$user46 === void 0 ? void 0 : (_vm$user46$personal_d = _vm$user46.personal_data) === null || _vm$user46$personal_d === void 0 ? void 0 : (_vm$user46$personal_d2 = _vm$user46$personal_d.blood_type) === null || _vm$user46$personal_d2 === void 0 ? void 0 : _vm$user46$personal_d2.alias))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Agama")])]), _c('td', [_vm._v(_vm._s((_vm$user47 = _vm.user) === null || _vm$user47 === void 0 ? void 0 : (_vm$user47$personal_d = _vm$user47.personal_data) === null || _vm$user47$personal_d === void 0 ? void 0 : (_vm$user47$personal_d2 = _vm$user47$personal_d.religion) === null || _vm$user47$personal_d2 === void 0 ? void 0 : _vm$user47$personal_d2.name))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Status")])]), _c('td', [_vm._v(_vm._s((_vm$user48 = _vm.user) === null || _vm$user48 === void 0 ? void 0 : (_vm$user48$personal_d = _vm$user48.personal_data) === null || _vm$user48$personal_d === void 0 ? void 0 : (_vm$user48$personal_d2 = _vm$user48$personal_d.marital_status) === null || _vm$user48$personal_d2 === void 0 ? void 0 : _vm$user48$personal_d2.name))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor Tlp./HP")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat17 = (_vm$user49 = _vm.user) === null || _vm$user49 === void 0 ? void 0 : (_vm$user49$personal_d = _vm$user49.personal_data) === null || _vm$user49$personal_d === void 0 ? void 0 : _vm$user49$personal_d.hp_number) !== null && _vm$user$personal_dat17 !== void 0 ? _vm$user$personal_dat17 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Email")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat18 = (_vm$user50 = _vm.user) === null || _vm$user50 === void 0 ? void 0 : (_vm$user50$personal_d = _vm$user50.personal_data) === null || _vm$user50$personal_d === void 0 ? void 0 : _vm$user50$personal_d.email) !== null && _vm$user$personal_dat18 !== void 0 ? _vm$user$personal_dat18 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Alamat KTP")])])]), _c('tr', [_vm.$route.query.user === 'candidate' ? _c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" " + _vm._s((_vm$user51 = _vm.user) === null || _vm$user51 === void 0 ? void 0 : (_vm$user51$alamat_ktp = _vm$user51.alamat_ktp) === null || _vm$user51$alamat_ktp === void 0 ? void 0 : (_vm$user51$alamat_ktp2 = _vm$user51$alamat_ktp[0]) === null || _vm$user51$alamat_ktp2 === void 0 ? void 0 : _vm$user51$alamat_ktp2.alamat) + ", No." + _vm._s((_vm$user52 = _vm.user) === null || _vm$user52 === void 0 ? void 0 : (_vm$user52$alamat_ktp = _vm$user52.alamat_ktp) === null || _vm$user52$alamat_ktp === void 0 ? void 0 : (_vm$user52$alamat_ktp2 = _vm$user52$alamat_ktp[0]) === null || _vm$user52$alamat_ktp2 === void 0 ? void 0 : _vm$user52$alamat_ktp2.no_rumah) + ", " + _vm._s((_vm$user53 = _vm.user) === null || _vm$user53 === void 0 ? void 0 : (_vm$user53$alamat_ktp = _vm$user53.alamat_ktp) === null || _vm$user53$alamat_ktp === void 0 ? void 0 : (_vm$user53$alamat_ktp2 = _vm$user53$alamat_ktp[0]) === null || _vm$user53$alamat_ktp2 === void 0 ? void 0 : _vm$user53$alamat_ktp2.provinsi) + ", " + _vm._s((_vm$user54 = _vm.user) === null || _vm$user54 === void 0 ? void 0 : (_vm$user54$alamat_ktp = _vm$user54.alamat_ktp) === null || _vm$user54$alamat_ktp === void 0 ? void 0 : (_vm$user54$alamat_ktp2 = _vm$user54$alamat_ktp[0]) === null || _vm$user54$alamat_ktp2 === void 0 ? void 0 : _vm$user54$alamat_ktp2.kabupaten) + ", " + _vm._s((_vm$user55 = _vm.user) === null || _vm$user55 === void 0 ? void 0 : (_vm$user55$alamat_ktp = _vm$user55.alamat_ktp) === null || _vm$user55$alamat_ktp === void 0 ? void 0 : (_vm$user55$alamat_ktp2 = _vm$user55$alamat_ktp[0]) === null || _vm$user55$alamat_ktp2 === void 0 ? void 0 : _vm$user55$alamat_ktp2.kecamatan) + ", " + _vm._s((_vm$user56 = _vm.user) === null || _vm$user56 === void 0 ? void 0 : (_vm$user56$alamat_ktp = _vm$user56.alamat_ktp) === null || _vm$user56$alamat_ktp === void 0 ? void 0 : (_vm$user56$alamat_ktp2 = _vm$user56$alamat_ktp[0]) === null || _vm$user56$alamat_ktp2 === void 0 ? void 0 : _vm$user56$alamat_ktp2.kelurahan) + ", " + _vm._s((_vm$user57 = _vm.user) === null || _vm$user57 === void 0 ? void 0 : (_vm$user57$alamat_ktp = _vm$user57.alamat_ktp) === null || _vm$user57$alamat_ktp === void 0 ? void 0 : (_vm$user57$alamat_ktp2 = _vm$user57$alamat_ktp[0]) === null || _vm$user57$alamat_ktp2 === void 0 ? void 0 : _vm$user57$alamat_ktp2.kode_pos) + " ")]) : _c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" " + _vm._s((_vm$user58 = _vm.user) === null || _vm$user58 === void 0 ? void 0 : (_vm$user58$address = _vm$user58.address) === null || _vm$user58$address === void 0 ? void 0 : (_vm$user58$address$ = _vm$user58$address[0]) === null || _vm$user58$address$ === void 0 ? void 0 : _vm$user58$address$.alamat) + ", No." + _vm._s((_vm$user59 = _vm.user) === null || _vm$user59 === void 0 ? void 0 : (_vm$user59$address = _vm$user59.address) === null || _vm$user59$address === void 0 ? void 0 : (_vm$user59$address$ = _vm$user59$address[0]) === null || _vm$user59$address$ === void 0 ? void 0 : _vm$user59$address$.no_rumah) + ", " + _vm._s((_vm$user60 = _vm.user) === null || _vm$user60 === void 0 ? void 0 : (_vm$user60$address = _vm$user60.address) === null || _vm$user60$address === void 0 ? void 0 : (_vm$user60$address$ = _vm$user60$address[0]) === null || _vm$user60$address$ === void 0 ? void 0 : _vm$user60$address$.provinsi) + ", " + _vm._s((_vm$user61 = _vm.user) === null || _vm$user61 === void 0 ? void 0 : (_vm$user61$address = _vm$user61.address) === null || _vm$user61$address === void 0 ? void 0 : (_vm$user61$address$ = _vm$user61$address[0]) === null || _vm$user61$address$ === void 0 ? void 0 : _vm$user61$address$.kabupaten) + ", " + _vm._s((_vm$user62 = _vm.user) === null || _vm$user62 === void 0 ? void 0 : (_vm$user62$address = _vm$user62.address) === null || _vm$user62$address === void 0 ? void 0 : (_vm$user62$address$ = _vm$user62$address[0]) === null || _vm$user62$address$ === void 0 ? void 0 : _vm$user62$address$.kecamatan) + ", " + _vm._s((_vm$user63 = _vm.user) === null || _vm$user63 === void 0 ? void 0 : (_vm$user63$address = _vm$user63.address) === null || _vm$user63$address === void 0 ? void 0 : (_vm$user63$address$ = _vm$user63$address[0]) === null || _vm$user63$address$ === void 0 ? void 0 : _vm$user63$address$.kelurahan) + ", " + _vm._s((_vm$user64 = _vm.user) === null || _vm$user64 === void 0 ? void 0 : (_vm$user64$address = _vm$user64.address) === null || _vm$user64$address === void 0 ? void 0 : (_vm$user64$address$ = _vm$user64$address[0]) === null || _vm$user64$address$ === void 0 ? void 0 : _vm$user64$address$.kode_pos) + " ")])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Alamat Domisili")])])]), _c('tr', [_vm.$route.query.user === 'candidate' ? _c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" " + _vm._s((_vm$user65 = _vm.user) === null || _vm$user65 === void 0 ? void 0 : (_vm$user65$alamat_dom = _vm$user65.alamat_domisili) === null || _vm$user65$alamat_dom === void 0 ? void 0 : (_vm$user65$alamat_dom2 = _vm$user65$alamat_dom[0]) === null || _vm$user65$alamat_dom2 === void 0 ? void 0 : _vm$user65$alamat_dom2.alamat) + ", No." + _vm._s((_vm$user66 = _vm.user) === null || _vm$user66 === void 0 ? void 0 : (_vm$user66$alamat_dom = _vm$user66.alamat_domisili) === null || _vm$user66$alamat_dom === void 0 ? void 0 : (_vm$user66$alamat_dom2 = _vm$user66$alamat_dom[0]) === null || _vm$user66$alamat_dom2 === void 0 ? void 0 : _vm$user66$alamat_dom2.no_rumah) + ", " + _vm._s((_vm$user67 = _vm.user) === null || _vm$user67 === void 0 ? void 0 : (_vm$user67$alamat_dom = _vm$user67.alamat_domisili) === null || _vm$user67$alamat_dom === void 0 ? void 0 : (_vm$user67$alamat_dom2 = _vm$user67$alamat_dom[0]) === null || _vm$user67$alamat_dom2 === void 0 ? void 0 : _vm$user67$alamat_dom2.provinsi) + ", " + _vm._s((_vm$user68 = _vm.user) === null || _vm$user68 === void 0 ? void 0 : (_vm$user68$alamat_dom = _vm$user68.alamat_domisili) === null || _vm$user68$alamat_dom === void 0 ? void 0 : (_vm$user68$alamat_dom2 = _vm$user68$alamat_dom[0]) === null || _vm$user68$alamat_dom2 === void 0 ? void 0 : _vm$user68$alamat_dom2.kabupaten) + ", " + _vm._s((_vm$user69 = _vm.user) === null || _vm$user69 === void 0 ? void 0 : (_vm$user69$alamat_dom = _vm$user69.alamat_domisili) === null || _vm$user69$alamat_dom === void 0 ? void 0 : (_vm$user69$alamat_dom2 = _vm$user69$alamat_dom[0]) === null || _vm$user69$alamat_dom2 === void 0 ? void 0 : _vm$user69$alamat_dom2.kecamatan) + ", " + _vm._s((_vm$user70 = _vm.user) === null || _vm$user70 === void 0 ? void 0 : (_vm$user70$alamat_dom = _vm$user70.alamat_domisili) === null || _vm$user70$alamat_dom === void 0 ? void 0 : (_vm$user70$alamat_dom2 = _vm$user70$alamat_dom[0]) === null || _vm$user70$alamat_dom2 === void 0 ? void 0 : _vm$user70$alamat_dom2.kelurahan) + ", " + _vm._s((_vm$user71 = _vm.user) === null || _vm$user71 === void 0 ? void 0 : (_vm$user71$alamat_dom = _vm$user71.alamat_domisili) === null || _vm$user71$alamat_dom === void 0 ? void 0 : (_vm$user71$alamat_dom2 = _vm$user71$alamat_dom[0]) === null || _vm$user71$alamat_dom2 === void 0 ? void 0 : _vm$user71$alamat_dom2.kode_pos) + " ")]) : _c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" " + _vm._s((_vm$user72 = _vm.user) === null || _vm$user72 === void 0 ? void 0 : (_vm$user72$address = _vm$user72.address) === null || _vm$user72$address === void 0 ? void 0 : (_vm$user72$address$ = _vm$user72$address[1]) === null || _vm$user72$address$ === void 0 ? void 0 : _vm$user72$address$.alamat) + ", No." + _vm._s((_vm$user73 = _vm.user) === null || _vm$user73 === void 0 ? void 0 : (_vm$user73$address = _vm$user73.address) === null || _vm$user73$address === void 0 ? void 0 : (_vm$user73$address$ = _vm$user73$address[1]) === null || _vm$user73$address$ === void 0 ? void 0 : _vm$user73$address$.no_rumah) + ", " + _vm._s((_vm$user74 = _vm.user) === null || _vm$user74 === void 0 ? void 0 : (_vm$user74$address = _vm$user74.address) === null || _vm$user74$address === void 0 ? void 0 : (_vm$user74$address$ = _vm$user74$address[1]) === null || _vm$user74$address$ === void 0 ? void 0 : _vm$user74$address$.provinsi) + ", " + _vm._s((_vm$user75 = _vm.user) === null || _vm$user75 === void 0 ? void 0 : (_vm$user75$address = _vm$user75.address) === null || _vm$user75$address === void 0 ? void 0 : (_vm$user75$address$ = _vm$user75$address[1]) === null || _vm$user75$address$ === void 0 ? void 0 : _vm$user75$address$.kabupaten) + ", " + _vm._s((_vm$user76 = _vm.user) === null || _vm$user76 === void 0 ? void 0 : (_vm$user76$address = _vm$user76.address) === null || _vm$user76$address === void 0 ? void 0 : (_vm$user76$address$ = _vm$user76$address[1]) === null || _vm$user76$address$ === void 0 ? void 0 : _vm$user76$address$.kecamatan) + ", " + _vm._s((_vm$user77 = _vm.user) === null || _vm$user77 === void 0 ? void 0 : (_vm$user77$address = _vm$user77.address) === null || _vm$user77$address === void 0 ? void 0 : (_vm$user77$address$ = _vm$user77$address[1]) === null || _vm$user77$address$ === void 0 ? void 0 : _vm$user77$address$.kelurahan) + ", " + _vm._s((_vm$user78 = _vm.user) === null || _vm$user78 === void 0 ? void 0 : (_vm$user78$address = _vm$user78.address) === null || _vm$user78$address === void 0 ? void 0 : (_vm$user78$address$ = _vm$user78$address[1]) === null || _vm$user78$address$ === void 0 ? void 0 : _vm$user78$address$.kode_pos) + " ")])])])])];
      },
      proxy: true
    }])
  }), _vm.$route.query.user === 'crew' ? _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$user$personal_dat19, _vm$user79, _vm$user79$personal_d;
        return [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Recommendation By")])])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v(_vm._s((_vm$user$personal_dat19 = (_vm$user79 = _vm.user) === null || _vm$user79 === void 0 ? void 0 : (_vm$user79$personal_d = _vm$user79.personal_data) === null || _vm$user79$personal_d === void 0 ? void 0 : _vm$user79$personal_d.recommendation_by) !== null && _vm$user$personal_dat19 !== void 0 ? _vm$user$personal_dat19 : '-'))])])])])])];
      },
      proxy: true
    }], null, false, 3108029527)
  }) : _vm._e(), _vm.$route.query.user === 'crew' ? _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$user80, _vm$user80$personal_d, _vm$user$personal_dat20, _vm$user81, _vm$user81$personal_d, _vm$user82, _vm$user82$personal_d, _vm$user84, _vm$user84$personal_d, _vm$user85, _vm$user85$personal_d;
        return [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Verification Kemenhub")])])]), (_vm$user80 = _vm.user) !== null && _vm$user80 !== void 0 && (_vm$user80$personal_d = _vm$user80.personal_data) !== null && _vm$user80$personal_d !== void 0 && _vm$user80$personal_d.verification_by ? _c('tr', [_c('td', [_c('strong', [_vm._v("Verification By")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat20 = (_vm$user81 = _vm.user) === null || _vm$user81 === void 0 ? void 0 : (_vm$user81$personal_d = _vm$user81.personal_data) === null || _vm$user81$personal_d === void 0 ? void 0 : _vm$user81$personal_d.verification_by) !== null && _vm$user$personal_dat20 !== void 0 ? _vm$user$personal_dat20 : '-'))])]) : _vm._e(), (_vm$user82 = _vm.user) !== null && _vm$user82 !== void 0 && (_vm$user82$personal_d = _vm$user82.personal_data) !== null && _vm$user82$personal_d !== void 0 && _vm$user82$personal_d.seaferer_code_verification_url ? _c('tr', [_c('td', {
          attrs: {
            "width": "50%"
          }
        }, [_c('strong', [_vm._v("Verification File")])]), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fas fa-download mr-2 text-primary",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function click($event) {
              var _vm$user83, _vm$user83$personal_d;
              return _vm.handleOpenFilePreview((_vm$user83 = _vm.user) === null || _vm$user83 === void 0 ? void 0 : (_vm$user83$personal_d = _vm$user83.personal_data) === null || _vm$user83$personal_d === void 0 ? void 0 : _vm$user83$personal_d.seaferer_code_verification_url);
            }
          }
        })])]) : _vm._e(), !((_vm$user84 = _vm.user) !== null && _vm$user84 !== void 0 && (_vm$user84$personal_d = _vm$user84.personal_data) !== null && _vm$user84$personal_d !== void 0 && _vm$user84$personal_d.verification_by) && !((_vm$user85 = _vm.user) !== null && _vm$user85 !== void 0 && (_vm$user85$personal_d = _vm$user85.personal_data) !== null && _vm$user85$personal_d !== void 0 && _vm$user85$personal_d.seaferer_code_verification_url) ? _c('tr', [_c('td', {
          attrs: {
            "width": "100%"
          }
        }, [_c('strong', {
          staticClass: "text-muted"
        }, [_vm._v("CANDIDATE BELUM MELAKUKAN VERIFICATION")])])]) : _vm._e()])])];
      },
      proxy: true
    }], null, false, 1489081428)
  }) : _vm._e(), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$user$personal_dat21, _vm$user86, _vm$user86$personal_d, _vm$user$personal_dat22, _vm$user87, _vm$user87$personal_d, _vm$user$personal_dat23, _vm$user88, _vm$user88$personal_d, _vm$user$personal_dat24, _vm$user89, _vm$user89$personal_d, _vm$user$personal_dat25, _vm$user90, _vm$user90$personal_d;
        return [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("PAKAIAN & SEPATU")])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Tinggi Badan")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat21 = (_vm$user86 = _vm.user) === null || _vm$user86 === void 0 ? void 0 : (_vm$user86$personal_d = _vm$user86.personal_data) === null || _vm$user86$personal_d === void 0 ? void 0 : _vm$user86$personal_d.height) !== null && _vm$user$personal_dat21 !== void 0 ? _vm$user$personal_dat21 : '-') + " CM")])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Berat Badan")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat22 = (_vm$user87 = _vm.user) === null || _vm$user87 === void 0 ? void 0 : (_vm$user87$personal_d = _vm$user87.personal_data) === null || _vm$user87$personal_d === void 0 ? void 0 : _vm$user87$personal_d.weight) !== null && _vm$user$personal_dat22 !== void 0 ? _vm$user$personal_dat22 : '-') + " KG")])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Wearpack")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat23 = (_vm$user88 = _vm.user) === null || _vm$user88 === void 0 ? void 0 : (_vm$user88$personal_d = _vm$user88.personal_data) === null || _vm$user88$personal_d === void 0 ? void 0 : _vm$user88$personal_d.wearpack) !== null && _vm$user$personal_dat23 !== void 0 ? _vm$user$personal_dat23 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Sepatu")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat24 = (_vm$user89 = _vm.user) === null || _vm$user89 === void 0 ? void 0 : (_vm$user89$personal_d = _vm$user89.personal_data) === null || _vm$user89$personal_d === void 0 ? void 0 : _vm$user89$personal_d.size_of_shoes) !== null && _vm$user$personal_dat24 !== void 0 ? _vm$user$personal_dat24 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Helmet")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat25 = (_vm$user90 = _vm.user) === null || _vm$user90 === void 0 ? void 0 : (_vm$user90$personal_d = _vm$user90.personal_data) === null || _vm$user90$personal_d === void 0 ? void 0 : _vm$user90$personal_d.helmet) !== null && _vm$user$personal_dat25 !== void 0 ? _vm$user$personal_dat25 : '-'))])])])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$user$personal_dat26, _vm$user91, _vm$user91$personal_d, _vm$user$personal_dat27, _vm$user92, _vm$user92$personal_d, _vm$user92$personal_d2, _vm$user93, _vm$user93$personal_d, _vm$user93$personal_d2, _vm$user$personal_dat28, _vm$user94, _vm$user94$personal_d;
        return [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("AKUN BANK")])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Atas Nama")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat26 = (_vm$user91 = _vm.user) === null || _vm$user91 === void 0 ? void 0 : (_vm$user91$personal_d = _vm$user91.personal_data) === null || _vm$user91$personal_d === void 0 ? void 0 : _vm$user91$personal_d.rekening_name) !== null && _vm$user$personal_dat26 !== void 0 ? _vm$user$personal_dat26 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nama Bank")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat27 = (_vm$user92 = _vm.user) === null || _vm$user92 === void 0 ? void 0 : (_vm$user92$personal_d = _vm$user92.personal_data) === null || _vm$user92$personal_d === void 0 ? void 0 : (_vm$user92$personal_d2 = _vm$user92$personal_d.bank) === null || _vm$user92$personal_d2 === void 0 ? void 0 : _vm$user92$personal_d2.name) !== null && _vm$user$personal_dat27 !== void 0 ? _vm$user$personal_dat27 : '-') + " (" + _vm._s((_vm$user93 = _vm.user) === null || _vm$user93 === void 0 ? void 0 : (_vm$user93$personal_d = _vm$user93.personal_data) === null || _vm$user93$personal_d === void 0 ? void 0 : (_vm$user93$personal_d2 = _vm$user93$personal_d.bank) === null || _vm$user93$personal_d2 === void 0 ? void 0 : _vm$user93$personal_d2.alias) + ")")])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor Rekening")])]), _c('td', [_vm._v(_vm._s((_vm$user$personal_dat28 = (_vm$user94 = _vm.user) === null || _vm$user94 === void 0 ? void 0 : (_vm$user94$personal_d = _vm$user94.personal_data) === null || _vm$user94$personal_d === void 0 ? void 0 : _vm$user94$personal_d.rekening_number) !== null && _vm$user$personal_dat28 !== void 0 ? _vm$user$personal_dat28 : '-'))])])])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$user$family$0$nam, _vm$user95, _vm$user95$family, _vm$user95$family$, _vm$user$family$0$no_, _vm$user96, _vm$user96$family, _vm$user96$family$, _vm$user$family$0$sta, _vm$user97, _vm$user97$family, _vm$user97$family$, _vm$user$family$0$ala, _vm$user98, _vm$user98$family, _vm$user98$family$;
        return [_c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', {
          staticClass: "bg-info"
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("EMERGENCY CALL")])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nama Lengkap")])]), _c('td', [_vm._v(_vm._s((_vm$user$family$0$nam = (_vm$user95 = _vm.user) === null || _vm$user95 === void 0 ? void 0 : (_vm$user95$family = _vm$user95.family) === null || _vm$user95$family === void 0 ? void 0 : (_vm$user95$family$ = _vm$user95$family[0]) === null || _vm$user95$family$ === void 0 ? void 0 : _vm$user95$family$.nama_lengkap) !== null && _vm$user$family$0$nam !== void 0 ? _vm$user$family$0$nam : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("No. Tlp/HP")])]), _c('td', [_vm._v(_vm._s((_vm$user$family$0$no_ = (_vm$user96 = _vm.user) === null || _vm$user96 === void 0 ? void 0 : (_vm$user96$family = _vm$user96.family) === null || _vm$user96$family === void 0 ? void 0 : (_vm$user96$family$ = _vm$user96$family[0]) === null || _vm$user96$family$ === void 0 ? void 0 : _vm$user96$family$.no_hp) !== null && _vm$user$family$0$no_ !== void 0 ? _vm$user$family$0$no_ : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Hubungan")])]), _c('td', [_vm._v(_vm._s((_vm$user$family$0$sta = (_vm$user97 = _vm.user) === null || _vm$user97 === void 0 ? void 0 : (_vm$user97$family = _vm$user97.family) === null || _vm$user97$family === void 0 ? void 0 : (_vm$user97$family$ = _vm$user97$family[0]) === null || _vm$user97$family$ === void 0 ? void 0 : _vm$user97$family$.status) !== null && _vm$user$family$0$sta !== void 0 ? _vm$user$family$0$sta : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("alamat")])]), _c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(" " + _vm._s((_vm$user$family$0$ala = (_vm$user98 = _vm.user) === null || _vm$user98 === void 0 ? void 0 : (_vm$user98$family = _vm$user98.family) === null || _vm$user98$family === void 0 ? void 0 : (_vm$user98$family$ = _vm$user98$family[0]) === null || _vm$user98$family$ === void 0 ? void 0 : _vm$user98$family$.alamat) !== null && _vm$user$family$0$ala !== void 0 ? _vm$user$family$0$ala : '-') + " ")])])])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "8"
    }
  }, [_vm.$route.query.user === 'crew' ? _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [((_vm$user99 = _vm.user) === null || _vm$user99 === void 0 ? void 0 : _vm$user99.position_id) === 1 || ((_vm$user100 = _vm.user) === null || _vm$user100 === void 0 ? void 0 : _vm$user100.position_id) === 2 ? _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        var _vm$user101, _vm$user101$position;
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("EVALUASI CONDUITE (" + _vm._s((_vm$user101 = _vm.user) === null || _vm$user101 === void 0 ? void 0 : (_vm$user101$position = _vm$user101.position) === null || _vm$user101$position === void 0 ? void 0 : _vm$user101$position.name) + ")")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user102, _vm$user102$conduct, _vm$user103, _vm$user104, _vm$user105;
        return [_c('b-row', {
          staticClass: "mb-3"
        }, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('span', [_vm._v(" Search Condite Date:")])]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.selectedMonth,
            expression: "selectedMonth"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "month"
          },
          domProps: {
            "value": _vm.selectedMonth
          },
          on: {
            "input": function input($event) {
              if ($event.target.composing) return;
              _vm.selectedMonth = $event.target.value;
            }
          }
        }), _c('small', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("click "), _c('i', {
          staticClass: "fa fa-calendar"
        }), _vm._v(" to show ")])])], 1), _c('b-row', {
          staticClass: "mb-4"
        }, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "table-responsive"
        }, [((_vm$user102 = _vm.user) === null || _vm$user102 === void 0 ? void 0 : (_vm$user102$conduct = _vm$user102.conduct) === null || _vm$user102$conduct === void 0 ? void 0 : _vm$user102$conduct.length) > 0 ? _c('table', {
          staticClass: "table table-striped table-hover mb-0",
          staticStyle: {
            "width": "1200px"
          }
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "align-middle text-center",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Tanggal Condite")]), _c('th', {
          staticClass: "align-middle text-center",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Periode Evaluasi")]), _c('th', {
          staticClass: "align-middle text-center",
          attrs: {
            "colspan": "4"
          }
        }, [_vm._v("Nama")]), _c('th', {
          staticClass: "align-middle text-center",
          attrs: {
            "colspan": "4"
          }
        }, [_vm._v("Rekomendasi")])]), _c('tr', [_c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Manager")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("User")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("KKM")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Master")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v(" Manager")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v(" User")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v(" KKM")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v(" Master")])]), _c('tr')]), _c('tbody', _vm._l((_vm$user103 = _vm.user) === null || _vm$user103 === void 0 ? void 0 : _vm$user103.condite, function (state, index) {
          var _state$evaluation_per, _state$name_manager, _state$name_user, _state$name, _state$name_master, _state$recommendation, _state$recommendation2, _state$recommendation3, _state$recommendation4;
          return _c('tr', {
            directives: [{
              name: "b-modal",
              rawName: "v-b-modal.condite",
              modifiers: {
                "condite": true
              }
            }],
            key: index,
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.modalCondite(state, index);
              }
            }
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(_vm.moment(new Date(state === null || state === void 0 ? void 0 : state.date_of_condite)).format('DD MMMM YYYY')))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$evaluation_per = state === null || state === void 0 ? void 0 : state.evaluation_period) !== null && _state$evaluation_per !== void 0 ? _state$evaluation_per : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$name_manager = state === null || state === void 0 ? void 0 : state.name_manager) !== null && _state$name_manager !== void 0 ? _state$name_manager : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$name_user = state === null || state === void 0 ? void 0 : state.name_user) !== null && _state$name_user !== void 0 ? _state$name_user : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$name = state === null || state === void 0 ? void 0 : state.name4) !== null && _state$name !== void 0 ? _state$name : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$name_master = state === null || state === void 0 ? void 0 : state.name_master) !== null && _state$name_master !== void 0 ? _state$name_master : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$recommendation = state === null || state === void 0 ? void 0 : state.recommendation_manager) !== null && _state$recommendation !== void 0 ? _state$recommendation : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$recommendation2 = state === null || state === void 0 ? void 0 : state.recommendation_user) !== null && _state$recommendation2 !== void 0 ? _state$recommendation2 : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$recommendation3 = state === null || state === void 0 ? void 0 : state.recommendation4) !== null && _state$recommendation3 !== void 0 ? _state$recommendation3 : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$recommendation4 = state === null || state === void 0 ? void 0 : state.recommendation_master) !== null && _state$recommendation4 !== void 0 ? _state$recommendation4 : '-'))])]);
        }), 0)]) : _vm._e(), ((_vm$user104 = _vm.user) === null || _vm$user104 === void 0 ? void 0 : _vm$user104.condite.length) <= 0 && ((_vm$user105 = _vm.user) === null || _vm$user105 === void 0 ? void 0 : _vm$user105.conduct.length) <= 0 ? _c('div', {
          staticClass: "d-flex w-100 justify-content-center align-items-center"
        }, [_c('strong', [_vm._v(" CREW BELUM MELAKUKAN CONDITE")])]) : _vm._e()])])], 1)];
      },
      proxy: true
    }], null, false, 2065710695)
  }) : _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        var _vm$user106, _vm$user106$position;
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("EVALUASI CONDUITE (" + _vm._s((_vm$user106 = _vm.user) === null || _vm$user106 === void 0 ? void 0 : (_vm$user106$position = _vm$user106.position) === null || _vm$user106$position === void 0 ? void 0 : _vm$user106$position.name) + ")")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user107, _vm$user107$conduct, _vm$user108, _vm$user109;
        return [_c('b-row', {
          staticClass: "mb-3"
        }, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('span', [_vm._v(" Search Condite Date:")])]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.selectedMonth,
            expression: "selectedMonth"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "month"
          },
          domProps: {
            "value": _vm.selectedMonth
          },
          on: {
            "input": function input($event) {
              if ($event.target.composing) return;
              _vm.selectedMonth = $event.target.value;
            }
          }
        }), _c('small', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("click "), _c('i', {
          staticClass: "fa fa-calendar"
        }), _vm._v(" to show ")])])], 1), _c('b-row', {
          staticClass: "mb-4"
        }, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "table-responsive"
        }, [((_vm$user107 = _vm.user) === null || _vm$user107 === void 0 ? void 0 : (_vm$user107$conduct = _vm$user107.conduct) === null || _vm$user107$conduct === void 0 ? void 0 : _vm$user107$conduct.length) > 0 ? _c('table', {
          staticClass: "table table-striped table-hover mb-0",
          staticStyle: {
            "width": "1200px"
          }
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "align-middle text-center",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Tanggal Condite")]), _c('th', {
          staticClass: "align-middle text-center",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Nama Evaluasi")]), _c('th', {
          staticClass: "align-middle text-center",
          attrs: {
            "colspan": "4"
          }
        }, [_vm._v("Nama")]), _c('th', {
          staticClass: "align-middle text-center",
          attrs: {
            "colspan": "4"
          }
        }, [_vm._v("Rekomendasi")])]), _c('tr', [_c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Approved By")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Checked By")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Rated By")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Verified By")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v(" Manager")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v(" User")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v(" KKM")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v(" Master")])]), _c('tr')]), _c('tbody', _vm._l((_vm$user108 = _vm.user) === null || _vm$user108 === void 0 ? void 0 : _vm$user108.conduct, function (state, index) {
          var _state$name_of_evalua, _state$approved_by, _state$checked_by, _state$rated_by, _state$verified_by, _state$recommendation5, _state$recommendation6, _state$recommendation7, _state$recommendation8;
          return _c('tr', {
            directives: [{
              name: "b-modal",
              rawName: "v-b-modal.condite",
              modifiers: {
                "condite": true
              }
            }],
            key: index,
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.modalConduct(state, index);
              }
            }
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(_vm.moment(new Date(state === null || state === void 0 ? void 0 : state.date_of_evaluation)).format('DD MMMM YYYY')))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$name_of_evalua = state === null || state === void 0 ? void 0 : state.name_of_evaluation) !== null && _state$name_of_evalua !== void 0 ? _state$name_of_evalua : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$approved_by = state === null || state === void 0 ? void 0 : state.approved_by) !== null && _state$approved_by !== void 0 ? _state$approved_by : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$checked_by = state === null || state === void 0 ? void 0 : state.checked_by) !== null && _state$checked_by !== void 0 ? _state$checked_by : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$rated_by = state === null || state === void 0 ? void 0 : state.rated_by) !== null && _state$rated_by !== void 0 ? _state$rated_by : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$verified_by = state === null || state === void 0 ? void 0 : state.verified_by) !== null && _state$verified_by !== void 0 ? _state$verified_by : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$recommendation5 = state === null || state === void 0 ? void 0 : state.recommendation1) !== null && _state$recommendation5 !== void 0 ? _state$recommendation5 : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$recommendation6 = state === null || state === void 0 ? void 0 : state.recommendation2) !== null && _state$recommendation6 !== void 0 ? _state$recommendation6 : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$recommendation7 = state === null || state === void 0 ? void 0 : state.recommendation3) !== null && _state$recommendation7 !== void 0 ? _state$recommendation7 : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$recommendation8 = state === null || state === void 0 ? void 0 : state.recommendation4) !== null && _state$recommendation8 !== void 0 ? _state$recommendation8 : '-'))])]);
        }), 0)]) : _vm._e(), ((_vm$user109 = _vm.user) === null || _vm$user109 === void 0 ? void 0 : _vm$user109.condite.length) <= 0 ? _c('div', {
          staticClass: "d-flex w-100 justify-content-center align-items-center"
        }, [_c('strong', [_vm._v(" CREW BELUM MELAKUKAN CONDITE")])]) : _vm._e()])])], 1)];
      },
      proxy: true
    }], null, false, 569484520)
  })], 1)], 1) : _vm._e(), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("INTERVIEW RESULT")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user110, _vm$user110$interview, _vm$user111, _vm$user112, _vm$user113, _vm$notes_by_section, _vm$notes_by_section$, _vm$user114, _vm$user115, _vm$user116, _vm$user117;
        return [((_vm$user110 = _vm.user) === null || _vm$user110 === void 0 ? void 0 : (_vm$user110$interview = _vm$user110.interview) === null || _vm$user110$interview === void 0 ? void 0 : _vm$user110$interview.length) > 0 ? _c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Urgensi Interview")])]), _c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(_vm._s((_vm$user111 = _vm.user) === null || _vm$user111 === void 0 ? void 0 : _vm$user111.interview[0].urgensi))])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Tanggal Interview")])]), _c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(_vm._s((_vm$user112 = _vm.user) === null || _vm$user112 === void 0 ? void 0 : _vm$user112.interview[0].date))])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Lokasi Interview")])]), _c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(_vm._s((_vm$user113 = _vm.user) === null || _vm$user113 === void 0 ? void 0 : _vm$user113.interview[0].location))])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Section By")])]), _c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(_vm._s((_vm$notes_by_section = _vm.notes_by_section) === null || _vm$notes_by_section === void 0 ? void 0 : (_vm$notes_by_section$ = _vm$notes_by_section[0]) === null || _vm$notes_by_section$ === void 0 ? void 0 : _vm$notes_by_section$.name))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Total Score")])]), _c('td', [_vm._v(_vm._s((_vm$user114 = _vm.user) === null || _vm$user114 === void 0 ? void 0 : _vm$user114.interview[0].total))]), _c('td', [_c('strong', [_vm._v("Average Score")])]), _c('td', [_vm._v(_vm._s((_vm$user115 = _vm.user) === null || _vm$user115 === void 0 ? void 0 : _vm$user115.interview[0].average))])]), _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('strong', [_vm._v("Status")])]), _c('td', {
          class: "text-center ".concat(((_vm$user116 = _vm.user) === null || _vm$user116 === void 0 ? void 0 : _vm$user116.interview[0].status) === 'Passed' ? 'text-success' : 'text-danger'),
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v(_vm._s((_vm$user117 = _vm.user) === null || _vm$user117 === void 0 ? void 0 : _vm$user117.interview[0].status))])])])]) : _c('div', {
          staticClass: "d-flex w-100 align-items-center justify-content-center"
        }, [_c('strong', {
          staticClass: "text-muted"
        }, [_vm._v("BELUM ADA DATA INTERVIEW")])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("MEDICAL CHECKUP")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user118, _vm$user118$medical_c, _vm$user119;
        return [((_vm$user118 = _vm.user) === null || _vm$user118 === void 0 ? void 0 : (_vm$user118$medical_c = _vm$user118.medical_checkup) === null || _vm$user118$medical_c === void 0 ? void 0 : _vm$user118$medical_c.length) > 0 ? _c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama File")]), _c('th', [_vm._v("File")])])]), _c('tbody', _vm._l((_vm$user119 = _vm.user) === null || _vm$user119 === void 0 ? void 0 : _vm$user119.medical_checkup, function (state, index) {
          var _state$nama_document;
          return _c('tr', {
            key: index
          }, [_c('td', {
            attrs: {
              "width": "90%"
            }
          }, [_vm._v(_vm._s((_state$nama_document = state === null || state === void 0 ? void 0 : state.nama_document) !== null && _state$nama_document !== void 0 ? _state$nama_document : 'N/A'))]), _c('td', {
            attrs: {
              "width": "10%"
            }
          }, [state.file ? _c('a', {
            attrs: {
              "href": ""
            }
          }, [_c('i', {
            staticClass: "fas fa-download mr-3 text-primary"
          })]) : _vm._e()])]);
        }), 0)]) : _c('div', {
          staticClass: "d-flex w-100 align-items-center justify-content-center"
        }, [_c('strong', {
          staticClass: "text-muted"
        }, [_vm._v("BELUM ADA DATA MEDICAL CHECKUP")])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("INDUCTION")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user120, _vm$user120$induction, _vm$user121;
        return [((_vm$user120 = _vm.user) === null || _vm$user120 === void 0 ? void 0 : (_vm$user120$induction = _vm$user120.induction) === null || _vm$user120$induction === void 0 ? void 0 : _vm$user120$induction.length) > 0 ? _c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('tr', [_c('th', [_c('strong', [_vm._v("Induction By")])]), _c('th', [_c('strong', [_vm._v("Date Induction")])]), _c('th', [_c('strong', [_vm._v("Notes")])]), _c('th', [_c('strong', [_vm._v("File")])])])]), _c('tbody', _vm._l((_vm$user121 = _vm.user) === null || _vm$user121 === void 0 ? void 0 : _vm$user121.induction, function (state, index) {
          var _state$induction_by, _state$induction_date, _state$notes;
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s((_state$induction_by = state === null || state === void 0 ? void 0 : state.induction_by) !== null && _state$induction_by !== void 0 ? _state$induction_by : '-'))]), _c('td', [_vm._v(_vm._s((_state$induction_date = state === null || state === void 0 ? void 0 : state.induction_date) !== null && _state$induction_date !== void 0 ? _state$induction_date : '-'))]), _c('td', [_vm._v(_vm._s((_state$notes = state === null || state === void 0 ? void 0 : state.notes) !== null && _state$notes !== void 0 ? _state$notes : '-'))]), _c('td', [state.attachment ? _c('a', {
            attrs: {
              "href": ""
            }
          }, [_c('i', {
            staticClass: "fas fa-download mr-3 text-primary"
          })]) : _vm._e()])]);
        }), 0)]) : _c('div', {
          staticClass: "d-flex w-100 align-items-center justify-content-center"
        }, [_c('strong', {
          staticClass: "text-muted"
        }, [_vm._v("BELUM ADA DATA INDUCTION")])])];
      },
      proxy: true
    }])
  }), _vm.$route.query.user === 'crew' ? _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("FLEET HISTORY")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user122, _vm$user122$history_p, _vm$user123;
        return [_c('div', {
          staticClass: "d-flex w-100 justify-content-end align-items-center mb-2"
        }, [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.swap-vehicle",
            modifiers: {
              "swap-vehicle": true
            }
          }],
          attrs: {
            "variant": "success",
            "type": "button"
          },
          on: {
            "click": function click() {
              _vm.resetFormSwapHistory();
              _vm.openModalSwapPosition(false);
              _vm.swap_form_edit = false;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" "), _c('span', [_vm._v("Tambah")])])], 1), _c('div', {
          staticClass: "overflow-auto"
        }, [((_vm$user122 = _vm.user) === null || _vm$user122 === void 0 ? void 0 : (_vm$user122$history_p = _vm$user122.history_position_swap) === null || _vm$user122$history_p === void 0 ? void 0 : _vm$user122$history_p.length) > 0 ? _c('table', {
          staticClass: "table table-striped mb-0",
          staticStyle: {
            "width": "1200px"
          }
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "align-middle text-left"
        }, [_vm._v("Nama   Lengkap")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Seaferer Code")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Nomor Pegawai")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Jabatan")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Company")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Fleet")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Port/Pelabuhan")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Join Onboard")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Sign On")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Sign Off")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Created By")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Status Crew")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Status Approval")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Reason")]), _c('th', {
          staticClass: "align-middle text-center"
        }, [_vm._v("Aksi")])])]), _c('tbody', _vm._l((_vm$user123 = _vm.user) === null || _vm$user123 === void 0 ? void 0 : _vm$user123.history_position_swap, function (state, index) {
          var _vm$user$fullname, _vm$user124, _vm$user$personal_dat29, _vm$user125, _vm$user125$personal_, _state$nip, _state$position$name, _state$position, _state$company$compan, _state$company, _state$vehicle$name, _state$vehicle, _state$port_id, _state$created_by, _state$status_emp_cre, _state$status_emp_cre2, _state$status_emp_cre3, _vm$val, _vm$val2, _vm$val3, _vm$val4, _vm$val5;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-left"
          }, [_vm._v(_vm._s((_vm$user$fullname = (_vm$user124 = _vm.user) === null || _vm$user124 === void 0 ? void 0 : _vm$user124.fullname) !== null && _vm$user$fullname !== void 0 ? _vm$user$fullname : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_vm$user$personal_dat29 = (_vm$user125 = _vm.user) === null || _vm$user125 === void 0 ? void 0 : (_vm$user125$personal_ = _vm$user125.personal_data) === null || _vm$user125$personal_ === void 0 ? void 0 : _vm$user125$personal_.seaferer_code) !== null && _vm$user$personal_dat29 !== void 0 ? _vm$user$personal_dat29 : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$nip = state === null || state === void 0 ? void 0 : state.nip) !== null && _state$nip !== void 0 ? _state$nip : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$position$name = state === null || state === void 0 ? void 0 : (_state$position = state.position) === null || _state$position === void 0 ? void 0 : _state$position.name) !== null && _state$position$name !== void 0 ? _state$position$name : '-') + " ")]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$company$compan = state === null || state === void 0 ? void 0 : (_state$company = state.company) === null || _state$company === void 0 ? void 0 : _state$company.company) !== null && _state$company$compan !== void 0 ? _state$company$compan : '-') + " ")]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$vehicle$name = state === null || state === void 0 ? void 0 : (_state$vehicle = state.vehicle) === null || _state$vehicle === void 0 ? void 0 : _state$vehicle.name) !== null && _state$vehicle$name !== void 0 ? _state$vehicle$name : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$port_id = state === null || state === void 0 ? void 0 : state.port_id) !== null && _state$port_id !== void 0 ? _state$port_id : '-'))]), _c('td', {
            staticClass: "text-center truncate"
          }, [_vm._v(_vm._s(_vm.moment(new Date(state === null || state === void 0 ? void 0 : state.join_on_board)).format('DD MMMM YYYY HH:mm')))]), _c('td', {
            staticClass: "text-center truncate"
          }, [_vm._v(_vm._s(_vm.moment(new Date(state === null || state === void 0 ? void 0 : state.start_date)).format('DD MMMM YYYY HH:mm')))]), _c('td', {
            staticClass: "text-center truncate"
          }, [_vm._v(_vm._s(state !== null && state !== void 0 && state.end_date ? _vm.moment(new Date(state === null || state === void 0 ? void 0 : state.end_date)).format('DD MMMM YYYY HH:mm') : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_state$created_by = state === null || state === void 0 ? void 0 : state.created_by) !== null && _state$created_by !== void 0 ? _state$created_by : '-'))]), _c('td', {
            class: "text-center ".concat((state === null || state === void 0 ? void 0 : (_state$status_emp_cre = state.status_emp_crewing) === null || _state$status_emp_cre === void 0 ? void 0 : _state$status_emp_cre.alias) === 'active' ? 'text-success' : (state === null || state === void 0 ? void 0 : (_state$status_emp_cre2 = state.status_emp_crewing) === null || _state$status_emp_cre2 === void 0 ? void 0 : _state$status_emp_cre2.alias) === 'blacklist' ? 'text-danger' : 'text-warning')
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$status_emp_cre3 = state.status_emp_crewing) === null || _state$status_emp_cre3 === void 0 ? void 0 : _state$status_emp_cre3.name))]), _c('td', [_c('div', [_c('span', {
            class: "text-center ".concat((state === null || state === void 0 ? void 0 : state.approval_status) === 'approved' ? 'text-success' : 'text-warning', " text-capitalize")
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.approval_status) + " "), _c('br'), (_vm$val = _vm.val) !== null && _vm$val !== void 0 && _vm$val.approval_by ? _c('small', [_vm._v("Approved by: " + _vm._s((_vm$val2 = _vm.val) === null || _vm$val2 === void 0 ? void 0 : _vm$val2.approval_by))]) : _vm._e(), _vm._v(" "), (_vm$val3 = _vm.val) !== null && _vm$val3 !== void 0 && _vm$val3.approval_by ? _c('br') : _vm._e(), (_vm$val4 = _vm.val) !== null && _vm$val4 !== void 0 && _vm$val4.approval_reason ? _c('small', {
            staticClass: "text-muted"
          }, [_vm._v("Reason: " + _vm._s((_vm$val5 = _vm.val) === null || _vm$val5 === void 0 ? void 0 : _vm$val5.approval_reason))]) : _vm._e()])])]), _c('td', {
            staticClass: "text-start"
          }, [_c('div', {
            staticClass: "gap-1"
          }, _vm._l(state.reason_sign_off_list, function (obj, index) {
            var _state$reason_blackli;
            return _c('div', {
              key: index + 'signoff-list'
            }, [_c('strong', {
              class: state.reason_blacklist_id ? 'text-danger' : ''
            }, [_vm._v(">")]), _vm._v(_vm._s(" ") + " "), state.reason_blacklist_id ? _c('span', {
              staticClass: "text-danger"
            }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$reason_blackli = state.reason_blacklist) === null || _state$reason_blackli === void 0 ? void 0 : _state$reason_blackli.name))]) : _c('span', [_vm._v(_vm._s(obj.name))]), _vm._v(" "), _c('br')]);
          }), 0)]), _c('td', {
            staticClass: "text-center"
          }, [_c('i', {
            staticClass: "fa fa-edit text-primary",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.openModalEdit(state);
              }
            }
          }), index !== 0 ? _c('br') : _vm._e(), index !== 0 ? _c('i', {
            staticClass: "fa fa-trash text-danger",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeleteFleetHistory(state.id);
              }
            }
          }) : _vm._e()])]);
        }), 0)]) : _c('div', {
          staticClass: "d-flex w-100 align-items-center justify-content-center"
        }, [_c('strong', {
          staticClass: "text-muted"
        }, [_vm._v("BELUM ADA DATA FLEET HISTORY")])])])];
      },
      proxy: true
    }], null, false, 3084070707)
  }) : _vm._e(), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("DATA KELUARGA")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user126, _vm$user127;
        return [_c('div', {
          staticClass: "d-flex w-100 justify-content-end align-items-center mb-2"
        }, [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.keluarga",
            modifiers: {
              "keluarga": true
            }
          }],
          attrs: {
            "variant": "success",
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.is_edit = false;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" "), _c('span', [_vm._v("Tambah")])])], 1), ((_vm$user126 = _vm.user) === null || _vm$user126 === void 0 ? void 0 : _vm$user126.family.length) > 0 ? _c('table', {
          staticClass: "table table-striped table-responsive mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Nama   Lengkap")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Hubungan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Jenis Kelamin")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Tempat/ Tanggal Lahir")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Umur")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Pekerjaan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("No.Hp")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Aksi")])])]), _c('tbody', _vm._l((_vm$user127 = _vm.user) === null || _vm$user127 === void 0 ? void 0 : _vm$user127.family, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-left"
          }, [_vm._v(_vm._s(state.nama_lengkap))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.status))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.jenis_kelamin))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.tempat_lahir) + "/" + _vm._s(_vm.moment(state.tanggal_lahir).format('DD MMMM YYYY')))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.age_family))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.pekerjaan))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.no_hp))]), _c('td', {
            staticClass: "text-center"
          }, [_c('i', {
            staticClass: "fa fa-edit text-primary",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.editKeluarga(state);
              }
            }
          }), _c('br'), _c('i', {
            staticClass: "fa fa-trash text-danger",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeleteKeluarga(state.id);
              }
            }
          })])]);
        }), 0)]) : _c('div', {
          staticClass: "d-flex w-100 justify-content-center align-items-center"
        }, [_c('strong', [_vm._v("DATA KELUARGA TIDAK ADA")])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("SERTIFIKAT KOMPETENSI")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user128, _vm$user129, _vm$user130, _vm$user131;
        return [_c('div', {
          staticClass: "d-flex w-100 justify-content-end align-items-center mb-2"
        }, [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.kompetensi",
            modifiers: {
              "kompetensi": true
            }
          }],
          attrs: {
            "variant": "success",
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.is_edit = false;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" "), _c('span', [_vm._v("Tambah")])])], 1), (_vm.$route.query.user === 'candidate' ? (_vm$user128 = _vm.user) === null || _vm$user128 === void 0 ? void 0 : _vm$user128.certificate_competency.length : (_vm$user129 = _vm.user) === null || _vm$user129 === void 0 ? void 0 : _vm$user129.certificate_of_competency.length) ? _c('table', {
          staticClass: "table table-striped table-responsive mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Nama Dokumen")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nomor Dokumen")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Tempat & Tanggal diterbitkan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Tanggal Berakhir")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("File")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Aksi")])])]), _c('tbody', _vm._l(_vm.$route.query.user === 'candidate' ? (_vm$user130 = _vm.user) === null || _vm$user130 === void 0 ? void 0 : _vm$user130.certificate_competency : (_vm$user131 = _vm.user) === null || _vm$user131 === void 0 ? void 0 : _vm$user131.certificate_of_competency, function (state, index) {
          var _state$certificate;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-left"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$certificate = state.certificate) === null || _state$certificate === void 0 ? void 0 : _state$certificate.name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_number))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.place_issued + ', ' + _vm.moment(state.date_issued).format('DD MMMM YYYY')))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.validity_period && state.validity_period !== 'null' ? _vm.moment(state.validity_period).format('DD MMMM YYYY') : '-'))]), state.file_url ? _c('td', {
            staticClass: "text-center",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.handleOpenFilePreview(state.file_url);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-file-alt text-primary"
          })]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s('-'))]), _c('td', {
            staticClass: "text-center"
          }, [_c('i', {
            staticClass: "fa fa-edit text-primary",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.editCompetency(state);
              }
            }
          }), _c('br'), _c('i', {
            staticClass: "fa fa-trash text-danger",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeleteCompetency(state.id);
              }
            }
          })])]);
        }), 0)]) : _c('div', {
          staticClass: "d-flex w-100 justify-content-center align-items-center"
        }, [_c('strong', [_vm._v("DATA SERTIFIKAT KOMPETENSI TIDAK ADA")])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("SERTIFIKAT PROFESI")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user132, _vm$user133, _vm$user134, _vm$user135;
        return [_c('div', {
          staticClass: "d-flex w-100 justify-content-end align-items-center mb-2"
        }, [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.profesi",
            modifiers: {
              "profesi": true
            }
          }],
          attrs: {
            "variant": "success",
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.is_edit = false;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" "), _c('span', [_vm._v("Tambah")])])], 1), (_vm.$route.query.user === 'candidate' ? (_vm$user132 = _vm.user) === null || _vm$user132 === void 0 ? void 0 : _vm$user132.certificate_proficiency.length : (_vm$user133 = _vm.user) === null || _vm$user133 === void 0 ? void 0 : _vm$user133.certificate_of_proficiency.length) ? _c('table', {
          staticClass: "table table-striped table-responsive mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Nama Dokumen")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Nomor Dokumen")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Tempat & Tanggal diterbitkan")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Tanggal Berakhir")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("File")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Aksi")])])]), _c('tbody', _vm._l(_vm.$route.query.user === 'candidate' ? (_vm$user134 = _vm.user) === null || _vm$user134 === void 0 ? void 0 : _vm$user134.certificate_proficiency : (_vm$user135 = _vm.user) === null || _vm$user135 === void 0 ? void 0 : _vm$user135.certificate_of_proficiency, function (state, index) {
          var _state$certificate2;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-left"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$certificate2 = state.certificate) === null || _state$certificate2 === void 0 ? void 0 : _state$certificate2.name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_number))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.place_issued + ', ' + _vm.moment(state.date_issued).format('DD MMMM YYYY')))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.validity_period && state.validity_period !== 'null' ? _vm.moment(state.validity_period).format('DD MMMM YYYY') : '-'))]), state.file_url ? _c('td', {
            staticClass: "text-center",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.handleOpenFilePreview(state.file_url);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-file-alt text-primary"
          })]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s('-'))]), _c('td', {
            staticClass: "text-center"
          }, [_c('i', {
            staticClass: "fa fa-edit text-primary",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.editProficiency(state);
              }
            }
          }), _c('br'), _c('i', {
            staticClass: "fa fa-trash text-danger",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeleteProficiency(state.id);
              }
            }
          })])]);
        }), 0)]) : _c('div', {
          staticClass: "d-flex w-100 justify-content-center align-items-center"
        }, [_c('strong', [_vm._v("DATA SERTIFIKAT PROFESI TIDAK ADA")])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("PENGALAMAN BERLAYAR")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user136, _vm$user136$pekerjaan, _vm$user137, _vm$user137$work_expe, _vm$user138, _vm$user139;
        return [_c('div', {
          staticClass: "d-flex w-100 justify-content-end align-items-center mb-2"
        }, [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.pengalaman_berlayar",
            modifiers: {
              "pengalaman_berlayar": true
            }
          }],
          attrs: {
            "variant": "success",
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.is_edit = false;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" "), _c('span', [_vm._v("Tambah")])])], 1), _c('div', {
          staticClass: "table-responsive"
        }, [(_vm.$route.query.user === 'candidate' ? (_vm$user136 = _vm.user) === null || _vm$user136 === void 0 ? void 0 : (_vm$user136$pekerjaan = _vm$user136.pekerjaan) === null || _vm$user136$pekerjaan === void 0 ? void 0 : _vm$user136$pekerjaan.length : (_vm$user137 = _vm.user) === null || _vm$user137 === void 0 ? void 0 : (_vm$user137$work_expe = _vm$user137.work_experience) === null || _vm$user137$work_expe === void 0 ? void 0 : _vm$user137$work_expe.length) ? _c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Perusahaan")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Negara")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Lokasi")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Nama Kapal")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Bendera Kapal")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Area Operasi")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("Periode of Service")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Jabatan")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Gaji")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Deskripsi Pekerjaan")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Fasilitas")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Pemberi Rekomendasi")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Kontak Pemberi Rekomendasi")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("No Perusahaan")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Alasan Berhenti")]), _c('th', {
          staticClass: "text-center align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Aksi")])]), _c('tr', [_c('th', {
          staticClass: "text-center align-middle w-50"
        }, [_vm._v(" Tahun Masuk ")]), _c('th', {
          staticClass: "text-center align-middle w-50"
        }, [_vm._v(" Tahun Berhenti ")])])]), _c('tbody', _vm._l(_vm.$route.query.user === 'candidate' ? (_vm$user138 = _vm.user) === null || _vm$user138 === void 0 ? void 0 : _vm$user138.pekerjaan : (_vm$user139 = _vm.user) === null || _vm$user139 === void 0 ? void 0 : _vm$user139.work_experience, function (state, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-left"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.perusahaan))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.negara))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.lokasi))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.nama_kapal))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.bendera_kapal))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.area_operasi))]), _c('td', {
            staticClass: "text-center w-50"
          }, [_vm._v(_vm._s(state !== null && state !== void 0 && state.tahun_masuk && (state === null || state === void 0 ? void 0 : state.tahun_masuk) !== 'null' ? _vm.moment(new Date(state === null || state === void 0 ? void 0 : state.tahun_masuk)).format('DD MMMM YYYY') : '-'))]), _c('td', {
            staticClass: "text-center w-50"
          }, [_vm._v(_vm._s(state !== null && state !== void 0 && state.tahun_berhenti && (state === null || state === void 0 ? void 0 : state.tahun_berhenti) !== 'null' ? _vm.moment(new Date(state === null || state === void 0 ? void 0 : state.tahun_berhenti)).format('DD MMMM YYYY') : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.jabatan))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(_vm.formatCurrency(state === null || state === void 0 ? void 0 : state.gaji)))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.deskripsi_pekerjaan))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.fasilitas))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.pemberi_rekomendasi))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.kontak_pemberi_informasi))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.no_tlp_perusahaan))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.alasan_berhenti))]), _c('td', {
            staticClass: "text-center"
          }, [_c('i', {
            staticClass: "fa fa-edit text-primary",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.editPekerjaan(state);
              }
            }
          }), _c('br'), _c('i', {
            staticClass: "fa fa-trash text-danger",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeletePekerjaan(state.id);
              }
            }
          })])]);
        }), 0)]) : _c('div', {
          staticClass: "d-flex w-100 justify-content-center align-items-center"
        }, [_c('strong', [_vm._v("DATA PENGALAMAN BERLAYAR TIDAK ADA")])])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("DOKUMEN PERJALANAN")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user140, _vm$user141;
        return [_c('div', {
          staticClass: "d-flex w-100 justify-content-end align-items-center mb-2"
        }, [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.dokumen_perjalanan",
            modifiers: {
              "dokumen_perjalanan": true
            }
          }],
          attrs: {
            "variant": "success",
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.is_edit = false;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" "), _c('span', [_vm._v("Tambah")])])], 1), ((_vm$user140 = _vm.user) === null || _vm$user140 === void 0 ? void 0 : _vm$user140.travel_document.length) > 0 ? _c('table', {
          staticClass: "table table-striped table-responsive mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Nama Document")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("No Dokumen")]), _c('th', {
          staticClass: "text-center w-50"
        }, [_vm._v("Place & Date Issued")]), _c('th', {
          staticClass: "text-center w-50"
        }, [_vm._v("Masa Berlaku")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("File")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Aksi")])])]), _c('tbody', _vm._l((_vm$user141 = _vm.user) === null || _vm$user141 === void 0 ? void 0 : _vm$user141.travel_document, function (state, index) {
          var _state$document_list;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-left"
          }, [_vm._v(_vm._s((_state$document_list = state.document_list) === null || _state$document_list === void 0 ? void 0 : _state$document_list.name))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.document_number))]), _c('td', {
            staticClass: "text-center w-50"
          }, [_vm._v(_vm._s(state.place_issued + ', ' + _vm.moment(state.date_issued).format('DD MMMM YYYY')))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(state.validity_period && state.validity_period !== 'null' ? _vm.moment(state.validity_period).format('DD MMMM YYYY') : '-'))]), state.file_url ? _c('td', {
            staticClass: "text-center",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.handleOpenFilePreview(state.file_url);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-file-alt text-primary"
          })]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s('-'))]), _c('td', {
            staticClass: "text-center"
          }, [_c('i', {
            staticClass: "fa fa-edit text-primary",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.editTravelDokumen(state);
              }
            }
          }), _c('br'), _c('i', {
            staticClass: "fa fa-trash text-danger",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeleteTravelDokumen(state.id);
              }
            }
          })])]);
        }), 0)]) : _c('div', {
          staticClass: "d-flex w-100 justify-content-center align-items-center"
        }, [_c('strong', [_vm._v("DATA DOKUMEN PERJALANAN TIDAK ADA")])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_vm._v("DOKUMEN PENDUKUNG")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$user142, _vm$user142$support_d, _vm$user143;
        return [_c('div', {
          staticClass: "d-flex w-100 justify-content-end align-items-center mb-2"
        }, [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.dokumen_pendukung",
            modifiers: {
              "dokumen_pendukung": true
            }
          }],
          attrs: {
            "variant": "success",
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.is_edit = false;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" "), _c('span', [_vm._v("Tambah")])])], 1), ((_vm$user142 = _vm.user) === null || _vm$user142 === void 0 ? void 0 : (_vm$user142$support_d = _vm$user142.support_document) === null || _vm$user142$support_d === void 0 ? void 0 : _vm$user142$support_d.length) > 0 ? _c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Nama Dokumen")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("File")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Aksi")])])]), _c('tbody', _vm._l((_vm$user143 = _vm.user) === null || _vm$user143 === void 0 ? void 0 : _vm$user143.support_document, function (state, index) {
          var _state$document_list$, _state$document_list2;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-left"
          }, [_vm._v(_vm._s((_state$document_list$ = state === null || state === void 0 ? void 0 : (_state$document_list2 = state.document_list) === null || _state$document_list2 === void 0 ? void 0 : _state$document_list2.name) !== null && _state$document_list$ !== void 0 ? _state$document_list$ : 'N/A'))]), state.file_url ? _c('td', {
            staticClass: "text-center",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.handleOpenFilePreview(state.file_url);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-file-alt text-primary"
          })]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s('-'))]), _c('td', {
            staticClass: "text-center"
          }, [_c('i', {
            staticClass: "fa fa-edit text-primary",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.editDokumenPendukung(state);
              }
            }
          }), _c('br'), _c('i', {
            staticClass: "fa fa-trash text-danger",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeleteDokumenPendukung(state.id);
              }
            }
          })])]);
        }), 0)]) : _c('div', {
          staticClass: "d-flex w-100 justify-content-center align-items-center"
        }, [_c('strong', [_vm._v("DATA DOKUMEN PENDUKUNG TIDAK ADA")])])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    staticClass: "pdf-exclude",
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        var _vm$user$personal_dat30, _vm$user144, _vm$user144$personal_;
        return [_c('h4', {
          staticClass: "card-title text-primary text-uppercase"
        }, [_vm._v("EXPORT PROFILE " + _vm._s(_vm.$route.query.user === 'candidate' ? 'Candidate' : 'Crew') + " - " + _vm._s((_vm$user$personal_dat30 = (_vm$user144 = _vm.user) === null || _vm$user144 === void 0 ? void 0 : (_vm$user144$personal_ = _vm$user144.personal_data) === null || _vm$user144$personal_ === void 0 ? void 0 : _vm$user144$personal_.full_name) !== null && _vm$user$personal_dat30 !== void 0 ? _vm$user$personal_dat30 : '-'))])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "block": "",
            "variant": "success",
            "type": "button",
            "disabled": _vm.isLoading
          },
          on: {
            "click": function click($event) {
              var _vm$user145, _vm$user145$personal_;
              return _vm.printPDF((_vm$user145 = _vm.user) === null || _vm$user145 === void 0 ? void 0 : (_vm$user145$personal_ = _vm$user145.personal_data) === null || _vm$user145$personal_ === void 0 ? void 0 : _vm$user145$personal_.full_name);
            }
          }
        }, [_vm.isLoading ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : _c('span', [_vm._v("Export to PDF")])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "size": "xl",
      "title": "Condite Crew",
      "cancel-title": "Close",
      "hide-footer": ""
    },
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [((_vm$user146 = _vm.user) === null || _vm$user146 === void 0 ? void 0 : _vm$user146.position_id) === 1 || ((_vm$user147 = _vm.user) === null || _vm$user147 === void 0 ? void 0 : _vm$user147.position_id) === 2 ? _c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Preview Condite")]), _c('b-row', [_c('FormCondite', {
    attrs: {
      "previewMode": true,
      "dataCondites": _vm.dataCondite
    }
  }), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('small', {
    staticClass: "mb-3"
  }, [_c('strong', [_vm._v("Rekomendasi oleh Nakhoda / Chief Officer "), _c('br')]), _vm._v(" Recommendation by Master")]), _c('b-form-textarea', {
    staticStyle: {
      "font-size": "9pt"
    },
    attrs: {
      "rows": "2",
      "placeholder": "Comments if any / Komentar jika ada",
      "disabled": "",
      "value": (_vm$conditeDetail = _vm.conditeDetail) === null || _vm$conditeDetail === void 0 ? void 0 : _vm$conditeDetail.recommendation_master
    }
  })], 1), _c('hr'), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-6",
    attrs: {
      "label": "Clasification *",
      "for": "nama_kandidiat"
    }
  }, [_vm._v("Wawancara Oleh")]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-form-input', {
    attrs: {
      "id": "job_name",
      "type": "text",
      "placeholder": "Nama",
      "disabled": "",
      "value": (_vm$conditeDetail2 = _vm.conditeDetail) === null || _vm$conditeDetail2 === void 0 ? void 0 : _vm$conditeDetail2.name_master,
      "required": ""
    }
  })], 1)])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('small', {
    staticClass: "mb-3"
  }, [_c('strong', [_vm._v("Rekomendasi oleh KKM (khusus untuk crew bagian mesin) "), _c('br')]), _vm._v(" Recommendation by Chief Engineer (only for engine crew)")]), _c('b-form-textarea', {
    staticStyle: {
      "font-size": "9pt"
    },
    attrs: {
      "rows": "2",
      "placeholder": "Comments if any / Komentar jika ada",
      "disabled": "",
      "value": (_vm$conditeDetail3 = _vm.conditeDetail) === null || _vm$conditeDetail3 === void 0 ? void 0 : _vm$conditeDetail3.recommendation_user,
      "required": ""
    }
  })], 1), _c('hr'), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-6",
    attrs: {
      "label": "Clasification *",
      "for": "nama_kandidiat"
    }
  }, [_vm._v("Wawancara Oleh")]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-form-input', {
    attrs: {
      "id": "job_name",
      "type": "text",
      "placeholder": "Nama",
      "disabled": "",
      "value": (_vm$conditeDetail4 = _vm.conditeDetail) === null || _vm$conditeDetail4 === void 0 ? void 0 : _vm$conditeDetail4.name_user,
      "required": ""
    }
  })], 1)])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('small', {
    staticClass: "mb-3"
  }, [_c('strong', [_vm._v("Rekomendasi oleh Port Captain / Port Engineer "), _c('br')]), _vm._v(" Recommendation by Port Captain / Port Engineer")]), _c('b-form-textarea', {
    staticStyle: {
      "font-size": "9pt"
    },
    attrs: {
      "rows": "2",
      "placeholder": "Comments if any / Komentar jika ada",
      "required": "",
      "disabled": "",
      "value": (_vm$conditeDetail5 = _vm.conditeDetail) === null || _vm$conditeDetail5 === void 0 ? void 0 : _vm$conditeDetail5.recommendation4
    }
  })], 1), _c('hr'), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-6",
    attrs: {
      "label": "Clasification *",
      "for": "nama_kandidiat"
    }
  }, [_vm._v("Wawancara Oleh")]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-form-input', {
    attrs: {
      "id": "job_name",
      "type": "text",
      "placeholder": "Nama",
      "disabled": "",
      "value": (_vm$conditeDetail6 = _vm.conditeDetail) === null || _vm$conditeDetail6 === void 0 ? void 0 : _vm$conditeDetail6.name4,
      "required": ""
    }
  })], 1)])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('small', {
    staticClass: "mb-3"
  }, [_c('strong', [_vm._v("Rekomendasi oleh Site Manager "), _c('br')]), _vm._v(" Recommendation by Site Manager")]), _c('b-form-textarea', {
    staticStyle: {
      "font-size": "9pt"
    },
    attrs: {
      "rows": "2",
      "placeholder": "Comments if any / Komentar jika ada",
      "required": "",
      "disabled": "",
      "value": (_vm$conditeDetail7 = _vm.conditeDetail) === null || _vm$conditeDetail7 === void 0 ? void 0 : _vm$conditeDetail7.recommendation_manager
    }
  })], 1), _c('hr'), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-6",
    attrs: {
      "label": "Clasification *",
      "for": "nama_kandidiat"
    }
  }, [_vm._v("Wawancara Oleh")]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-form-input', {
    attrs: {
      "id": "job_name",
      "type": "text",
      "placeholder": "Nama",
      "disabled": "",
      "value": (_vm$conditeDetail8 = _vm.conditeDetail) === null || _vm$conditeDetail8 === void 0 ? void 0 : _vm$conditeDetail8.name_manager,
      "required": ""
    }
  })], 1)])])], 1)], 1) : _c('div', [_c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("DESKRIPSI")]), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("PENILAIAN")]), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("NOTES")])])]), _c('tbody', _vm._l(_vm.merged_aspects, function (state, index) {
    return _c('tr', {
      key: index
    }, [_c('th', [_vm._v(_vm._s(state.content))]), _c('td', {
      staticClass: "text-center"
    }, [_c('b-form-select', {
      staticClass: "col-md-12",
      attrs: {
        "plain": "",
        "options": _vm.optionsPoints,
        "size": "sm",
        "required": ""
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null
            }
          }, [_vm._v("Nilai")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: state.value,
        callback: function callback($$v) {
          _vm.$set(state, "value", $$v);
        },
        expression: "state.value"
      }
    })], 1), _c('td', [_c('b-form-textarea', {
      attrs: {
        "rows": "4",
        "value": "Notes"
      },
      model: {
        value: state.remarks,
        callback: function callback($$v) {
          _vm.$set(state, "remarks", $$v);
        },
        expression: "state.remarks"
      }
    })], 1)]);
  }), 0)])])], 1)], 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "text-primary"
  }, [_vm._v("Disetujui Oleh / "), _c('i', [_vm._v("Approval by ")])]), _c('hr'), _c('b-form-group', {
    attrs: {
      "label": "PIC",
      "label-for": "pic"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.detailConduct.approved_by,
      "disabled": ""
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Notes / Remarks",
      "label-for": "pic"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "2",
      "value": _vm.detailConduct.recommendation1,
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "text-primary"
  }, [_vm._v("Diverifikasi Oleh / "), _c('i', [_vm._v("Verified by ")])]), _c('hr'), _c('b-form-group', {
    attrs: {
      "label": "PIC",
      "label-for": "pic"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.detailConduct.verified_by,
      "disabled": ""
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Notes / Remarks",
      "label-for": "pic"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "2",
      "value": _vm.detailConduct.recommendation2,
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "text-primary"
  }, [_vm._v("Diperiksa Oleh / "), _c('i', [_vm._v("Checked by ")])]), _c('hr'), _c('b-form-group', {
    attrs: {
      "label": "PIC",
      "label-for": "pic"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.detailConduct.checked_by,
      "disabled": ""
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Notes / Remarks",
      "label-for": "pic"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "2",
      "value": _vm.detailConduct.recommendation3,
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "text-primary"
  }, [_vm._v("Dinilai Oleh / "), _c('i', [_vm._v("Rated By ")])]), _c('hr'), _c('b-form-group', {
    attrs: {
      "label": "PIC",
      "label-for": "pic"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.detailConduct.rated_by,
      "disabled": ""
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Notes / Remarks",
      "label-for": "pic"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "2",
      "value": _vm.detailConduct.recommendation4,
      "disabled": ""
    }
  })], 1)], 1)], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "swap-vehicle",
      "size": "lg",
      "title": _vm.swap_form_edit ? 'Edit History Position' : 'Add History Position',
      "cancel-title": "Close",
      "hide-footer": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": _vm.onSaveSwapVehicle
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', [_c('b-row', [!_vm.swap_form_edit ? _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Swap ?",
      "label-for": "swap"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": ""
    },
    on: {
      "change": function change() {
        _vm.swap_form.status_emp_crewing = null;
      }
    },
    model: {
      value: _vm.swap_form.swap,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "swap", $$v);
      },
      expression: "swap_form.swap"
    }
  }, [_vm._v(_vm._s(_vm.swap_form.swap ? "Yes" : "No"))])], 1)], 1) : _vm._e(), _vm.swap_form.swap !== true ? _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status Crew",
      "label-for": "status_crew"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "options": _vm.options_status_crew_fleet,
      "size": "sm",
      "required": ""
    },
    on: {
      "change": function change() {
        _vm.swap_form.status_emp_crewing === 4 ? _vm.options_reason_signoff = _vm.options_reason_signoff.map(function (val) {
          return Object.assign({}, val, {
            disabled: val.id === 7 ? false : true,
            checked: val.id === 7 ? true : false
          });
        }) : _vm.options_reason_signoff = _vm.options_reason_signoff.map(function (val) {
          return Object.assign({}, val, {
            disabled: false,
            checked: false
          });
        });
      }
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("Select Status Crew")])];
      },
      proxy: true
    }], null, false, 4042986593),
    model: {
      value: _vm.swap_form.status_emp_crewing,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "status_emp_crewing", $$v);
      },
      expression: "swap_form.status_emp_crewing"
    }
  })], 1)], 1) : _vm._e(), _vm.swap_form.status_emp_crewing !== 1 && _vm.swap_form.status_emp_crewing !== null && _vm.swap_form.status_emp_crewing !== 5 && _vm.swap_form.swap !== true ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "text-black"
  }, [_vm._v("Reason Sign Off")]), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    attrs: {
      "width": "90%"
    }
  }, [_vm._v("DESKRIPSI")]), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("STATUS")])])]), _c('tbody', _vm._l(_vm.options_reason_signoff, function (state, index) {
    return _c('tr', {
      key: index
    }, [_c('th', [_vm._v(" " + _vm._s(state.name))]), _c('td', {
      staticClass: "text-center"
    }, [[_c('b-form-checkbox', {
      staticClass: "ml-4",
      attrs: {
        "name": "check-button",
        "switch": "",
        "inline": "",
        "disabled": state.disabled
      },
      on: {
        "change": function change($event) {
          return _vm.selectStatusSignOffCrew(state, index, 'swap');
        }
      },
      model: {
        value: state.checked,
        callback: function callback($$v) {
          _vm.$set(state, "checked", $$v);
        },
        expression: "state.checked"
      }
    })]], 2)]);
  }), 0)])]) : _vm._e(), (_vm$options_reason_si = _vm.options_reason_signoff) !== null && _vm$options_reason_si !== void 0 && (_vm$options_reason_si2 = _vm$options_reason_si[6]) !== null && _vm$options_reason_si2 !== void 0 && _vm$options_reason_si2.checked && _vm.swap_form.swap !== true ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Reason Blacklist"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "options": _vm.optionBlacklistReasons,
      "size": "lg",
      "aria-placeholder": "Pilih Alasan",
      "required": "",
      "name": "reason_off"
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("Pilih Alasan")])];
      },
      proxy: true
    }], null, false, 4088621210),
    model: {
      value: _vm.swap_form.reason_blacklist_id,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "reason_blacklist_id", $$v);
      },
      expression: "swap_form.reason_blacklist_id"
    }
  })], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Vehicles",
      "label-for": "vehicle_id"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.vehicleOptions,
      "reduce": function reduce(vehicleOptions) {
        return vehicleOptions.value;
      },
      "placeholder": "Select Type of Vehicle",
      "required": ""
    },
    model: {
      value: _vm.swap_form.vehicle_id,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "vehicle_id", $$v);
      },
      expression: "swap_form.vehicle_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Join on Board",
      "label-for": "join_on_board"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local",
      "id": "join_on_board",
      "required": ""
    },
    model: {
      value: _vm.swap_form.join_on_board,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "join_on_board", $$v);
      },
      expression: "swap_form.join_on_board"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Sign On",
      "label-for": "start_date"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local",
      "id": "start_date",
      "required": ""
    },
    model: {
      value: _vm.swap_form.start_date,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "start_date", $$v);
      },
      expression: "swap_form.start_date"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1)], 1), !_vm.swap_form.swap && Number(_vm.swap_form.status_emp_crewing) !== 1 ? _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Sign Off",
      "label-for": "end_date"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local",
      "id": "end_date",
      "required": _vm.swap_form.status_emp_crewing !== 1
    },
    model: {
      value: _vm.swap_form.end_date,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "end_date", $$v);
      },
      expression: "swap_form.end_date"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Company",
      "label-for": "company_id"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "size": "sm",
      "options": _vm.companyOptions,
      "required": "",
      "placeholder": "Select options..."
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": ''
          }
        }, [_vm._v("Select Company")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.swap_form.company_id,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "company_id", $$v);
      },
      expression: "swap_form.company_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Port"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.portOptions,
      "reduce": function reduce(portOptions) {
        return portOptions.value;
      },
      "placeholder": "Select port...",
      "required": ""
    },
    model: {
      value: _vm.swap_form.port_id,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "port_id", $$v);
      },
      expression: "swap_form.port_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Work Area",
      "label-for": "work_area_id"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "size": "sm",
      "options": _vm.workareaOptions,
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": ''
          }
        }, [_vm._v("Select Work Area")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.swap_form.work_area_id,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "work_area_id", $$v);
      },
      expression: "swap_form.work_area_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Position/Jabatan",
      "label-for": "position_id"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.master_list_position,
      "reduce": function reduce(master_list_position) {
        return master_list_position.value;
      },
      "placeholder": "Select Position",
      "required": ""
    },
    model: {
      value: _vm.swap_form.position_id,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "position_id", $$v);
      },
      expression: "swap_form.position_id"
    }
  })], 1)], 1), _c('b-form-group', {
    staticClass: "col-md-12",
    attrs: {
      "label": "Attachment",
      "label-for": "attachment"
    }
  }, [_c('div', {
    staticClass: "custom-file"
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "type": "file",
      "id": "validatedCustomFile",
      "accept": "application/*,image/png,image/jpeg,image/jpg"
    },
    on: {
      "change": function change(event) {
        return _vm.prefiewFiles(event, _vm.swap_form);
      }
    }
  }), !_vm.swap_form.file ? _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v("Browse file...")]) : _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v(_vm._s(_vm.swap_form.file_label))])]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" File Type * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File CapaKota * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("10 MB / File")])], 1)]), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "type": "textarea",
      "label": "Notes",
      "label-for": "remarks"
    }
  }, [_c('b-form-textarea', {
    staticClass: "form-control",
    attrs: {
      "id": "remarks",
      "name": "remarks",
      "rows": "3"
    },
    model: {
      value: _vm.swap_form.remarks,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_form, "remarks", $$v);
      },
      expression: "swap_form.remarks"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": '6'
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Close")])], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "block": "",
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [!_vm.saving ? _c('i', {
    staticClass: "fa fa-edit"
  }) : _vm._e(), !_vm.saving ? _c('span', [_vm._v("SUBMIT")]) : _vm._e(), _vm.saving ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _vm._e()])], 1)], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "keluarga",
      "size": "lg",
      "title": _vm.is_edit ? 'Update ' : 'Tambah ' + 'Data Keluarga',
      "cancel-title": "Close",
      "hide-footer": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": _vm.onSaveKeluarga
    }
  }, [!_vm.is_edit ? _c('fieldset', {
    staticClass: "form-group border p-3 mt-1"
  }, [_c('legend', {
    staticClass: "w-auto text-primary",
    staticStyle: {
      "font-size": "12pt"
    }
  }, [_vm._v("DATA KELUARGA")]), _vm._l(_vm.user_edit.keluarga, function (state, index) {
    return _c('div', {
      key: index
    }, [index > 0 ? _c('div', {
      staticClass: "d-flex w-100 px-1 my-1 justify-content-end cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.deleteFamilyForm(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e(), _c('b-row', [_c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Nama Lengkap",
        "label-for": "nama_lengkap"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "nama_lengkap",
        "name": "nama_lengkap",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.nama_lengkap,
        callback: function callback($$v) {
          _vm.$set(state, "nama_lengkap", $$v);
        },
        expression: "state.nama_lengkap"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Hubungan",
        "label-for": "hubungan"
      }
    }, [_c('b-form-select', {
      attrs: {
        "plain": "",
        "options": _vm.hubungan,
        "size": "sm",
        "required": ""
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null
            }
          }, [_vm._v("Select Hubungan")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: state.status,
        callback: function callback($$v) {
          _vm.$set(state, "status", $$v);
        },
        expression: "state.status"
      }
    })], 1)], 1), _c('b-row', [_c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Tempat Lahir",
        "label-for": "tempat_lahir"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "tempat_lahir",
        "name": "tempat_lahir",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.tempat_lahir,
        callback: function callback($$v) {
          _vm.$set(state, "tempat_lahir", $$v);
        },
        expression: "state.tempat_lahir"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Tanggal Lahir",
        "label-for": "tanggal_lahir"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "date",
        "id": "tanggal_lahir",
        "name": "tanggal_lahir",
        "placeholder": "Type Text ...",
        "required": ""
      },
      on: {
        "change": function change($event) {
          return _vm.calculateAge(state);
        }
      },
      model: {
        value: state.tanggal_lahir,
        callback: function callback($$v) {
          _vm.$set(state, "tanggal_lahir", $$v);
        },
        expression: "state.tanggal_lahir"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Umur",
        "label-for": "age_family"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "id": "age_family",
        "name": "age_family",
        "placeholder": "Type Number ...",
        "disabled": "",
        "required": ""
      },
      model: {
        value: state.age_family,
        callback: function callback($$v) {
          _vm.$set(state, "age_family", $$v);
        },
        expression: "state.age_family"
      }
    })], 1)], 1), _c('b-row', [_c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Jenis Kelamin",
        "label-for": "jenis_kelamin"
      }
    }, [_c('b-form-select', {
      attrs: {
        "plain": "",
        "options": _vm.jenisKelaminFamily,
        "size": "sm",
        "required": ""
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null
            }
          }, [_vm._v("Select Jenis Kelamin")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: state.jenis_kelamin,
        callback: function callback($$v) {
          _vm.$set(state, "jenis_kelamin", $$v);
        },
        expression: "state.jenis_kelamin"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Pekerjaan",
        "label-for": "pekerjaan"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "pekerjaan",
        "name": "pekerjaan",
        "required": ""
      },
      model: {
        value: state.pekerjaan,
        callback: function callback($$v) {
          _vm.$set(state, "pekerjaan", $$v);
        },
        expression: "state.pekerjaan"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "No. Tlp/Handphone",
        "label-for": "handphone"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "id": "handphone",
        "name": "handphone",
        "placeholder": "Type Number ...",
        "required": ""
      },
      model: {
        value: state.no_hp,
        callback: function callback($$v) {
          _vm.$set(state, "no_hp", $$v);
        },
        expression: "state.no_hp"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-12",
      attrs: {
        "label": "Alamat",
        "label-for": "alamat"
      }
    }, [_c('b-form-textarea', {
      attrs: {
        "id": "alamat",
        "name": "alamat",
        "rows": "3",
        "required": ""
      },
      model: {
        value: state.alamat,
        callback: function callback($$v) {
          _vm.$set(state, "alamat", $$v);
        },
        expression: "state.alamat"
      }
    })], 1), _vm.user_edit.keluarga.length > 1 ? _c('div', {
      staticClass: "d-flex w-100 px-2 my-1 border-bottom"
    }) : _vm._e()], 1)], 1);
  }), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addFamilyForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" ADD FORM ")])], 1)], 1)], 2) : _c('div', [_c('b-row', [_c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Nama Lengkap",
      "label-for": "nama_lengkap"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nama_lengkap",
      "name": "nama_lengkap",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_keluarga.nama_lengkap,
      callback: function callback($$v) {
        _vm.$set(_vm.update_keluarga, "nama_lengkap", $$v);
      },
      expression: "update_keluarga.nama_lengkap"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Hubungan",
      "label-for": "hubungan"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "options": _vm.hubungan,
      "size": "sm",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("Select Hubungan")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.update_keluarga.status,
      callback: function callback($$v) {
        _vm.$set(_vm.update_keluarga, "status", $$v);
      },
      expression: "update_keluarga.status"
    }
  })], 1)], 1), _c('b-row', [_c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Tempat Lahir",
      "label-for": "tempat_lahir"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "tempat_lahir",
      "name": "tempat_lahir",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_keluarga.tempat_lahir,
      callback: function callback($$v) {
        _vm.$set(_vm.update_keluarga, "tempat_lahir", $$v);
      },
      expression: "update_keluarga.tempat_lahir"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Tanggal Lahir",
      "label-for": "tanggal_lahir"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "tanggal_lahir",
      "name": "tanggal_lahir",
      "placeholder": "Type Text ...",
      "required": ""
    },
    on: {
      "change": function change($event) {
        return _vm.calculateAge(_vm.update_keluarga);
      }
    },
    model: {
      value: _vm.update_keluarga.tanggal_lahir,
      callback: function callback($$v) {
        _vm.$set(_vm.update_keluarga, "tanggal_lahir", $$v);
      },
      expression: "update_keluarga.tanggal_lahir"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Umur",
      "label-for": "age_family"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "id": "age_family",
      "name": "age_family",
      "placeholder": "Type Number ...",
      "disabled": "",
      "required": ""
    },
    model: {
      value: _vm.update_keluarga.age_family,
      callback: function callback($$v) {
        _vm.$set(_vm.update_keluarga, "age_family", $$v);
      },
      expression: "update_keluarga.age_family"
    }
  })], 1)], 1), _c('b-row', [_c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Jenis Kelamin",
      "label-for": "jenis_kelamin"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "options": _vm.jenisKelaminFamily,
      "size": "sm",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("Select Jenis Kelamin")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.update_keluarga.jenis_kelamin,
      callback: function callback($$v) {
        _vm.$set(_vm.update_keluarga, "jenis_kelamin", $$v);
      },
      expression: "update_keluarga.jenis_kelamin"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Pekerjaan",
      "label-for": "pekerjaan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "pekerjaan",
      "name": "pekerjaan",
      "required": ""
    },
    model: {
      value: _vm.update_keluarga.pekerjaan,
      callback: function callback($$v) {
        _vm.$set(_vm.update_keluarga, "pekerjaan", $$v);
      },
      expression: "update_keluarga.pekerjaan"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "No. Tlp/Handphone",
      "label-for": "handphone"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "id": "handphone",
      "name": "handphone",
      "placeholder": "Type Number ...",
      "required": ""
    },
    model: {
      value: _vm.update_keluarga.no_hp,
      callback: function callback($$v) {
        _vm.$set(_vm.update_keluarga, "no_hp", $$v);
      },
      expression: "update_keluarga.no_hp"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-12",
    attrs: {
      "label": "Alamat",
      "label-for": "alamat"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "alamat",
      "name": "alamat",
      "rows": "3",
      "required": ""
    },
    model: {
      value: _vm.update_keluarga.alamat,
      callback: function callback($$v) {
        _vm.$set(_vm.update_keluarga, "alamat", $$v);
      },
      expression: "update_keluarga.alamat"
    }
  })], 1)], 1)], 1), _c('b-button', {
    staticClass: "my-3",
    attrs: {
      "disabled": _vm.saving_keluarga,
      "block": "",
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm.saving_keluarga ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _c('span', [_vm._v(_vm._s(_vm.is_edit ? "Update" : "Tambah") + " Data Keluarga")])])], 1)]), _c('b-modal', {
    attrs: {
      "id": "kompetensi",
      "size": "lg",
      "title": _vm.is_edit ? 'Update Data Sertifikat Kompentensi' : 'Tambah Data Sertifikat Kompentensi',
      "cancel-title": "Close",
      "hide-footer": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": _vm.onSaveCompetency
    }
  }, [!_vm.is_edit ? _c('fieldset', {
    staticClass: "form-group border p-3 mt-1"
  }, [_c('legend', {
    staticClass: "w-auto text-primary",
    staticStyle: {
      "font-size": "12pt"
    }
  }, [_vm._v("SERTIFIKAT KOMPETENSI")]), _vm._l(_vm.user_edit.certificate_of_competency, function (state, index) {
    return _c('div', {
      key: index
    }, [index > 0 ? _c('div', {
      staticClass: "d-flex w-100 px-1 my-1 justify-content-end cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.deleteCertificateOfCompetencyForm(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e(), _c('b-row', [_c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Nama Dokumen",
        "label-for": "certificate_list_id"
      }
    }, [_c('v-select', {
      attrs: {
        "label": "text",
        "options": _vm.coc_options,
        "reduce": function reduce(coc_options) {
          return coc_options.value;
        },
        "placeholder": "Select certificate...",
        "name": "certificate_list_id",
        "required": ""
      },
      model: {
        value: state.certificate_list_id,
        callback: function callback($$v) {
          _vm.$set(state, "certificate_list_id", $$v);
        },
        expression: "state.certificate_list_id"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Level",
        "label-for": "sub_education"
      }
    }, [_c('b-form-select', {
      attrs: {
        "plain": "",
        "required": "",
        "size": "sm"
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": "none"
            }
          }, [_vm._v("Select Options")]), _c('b-form-select-option', {
            attrs: {
              "value": "management"
            }
          }, [_vm._v("Manajemen level")]), _c('b-form-select-option', {
            attrs: {
              "value": "operational"
            }
          }, [_vm._v("Operational level")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: state.sub_education,
        callback: function callback($$v) {
          _vm.$set(state, "sub_education", $$v);
        },
        expression: "state.sub_education"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "No Dokumen",
        "label-for": "nomor_sertifikat"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "nomor_sertifikat",
        "name": "nomor_sertifikat",
        "placeholder": "Type Number ...",
        "required": ""
      },
      model: {
        value: state.document_number,
        callback: function callback($$v) {
          _vm.$set(state, "document_number", $$v);
        },
        expression: "state.document_number"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Tanggal Terbit",
        "label-for": "date_issued"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "date",
        "id": "date_issued",
        "required": ""
      },
      model: {
        value: state.date_issued,
        callback: function callback($$v) {
          _vm.$set(state, "date_issued", $$v);
        },
        expression: "state.date_issued"
      }
    }), _c('small', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("click "), _c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" to show ")])], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Tanggal Berakhir",
        "label-for": "masa_berlaku"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "date",
        "id": "masa_berlaku"
      },
      model: {
        value: state.validity_period,
        callback: function callback($$v) {
          _vm.$set(state, "validity_period", $$v);
        },
        expression: "state.validity_period"
      }
    }), _c('small', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("click "), _c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" to show ")])], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Tempat diterbitkan",
        "label-for": "place_issued"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "place_issued",
        "name": "place_issued",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.place_issued,
        callback: function callback($$v) {
          _vm.$set(state, "place_issued", $$v);
        },
        expression: "state.place_issued"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-12",
      attrs: {
        "label": "Attachment",
        "label-for": "attachment"
      }
    }, [_c('div', {
      staticClass: "custom-file"
    }, [_c('input', {
      staticClass: "custom-file-input",
      attrs: {
        "type": "file",
        "id": "validatedCustomFile",
        "required": !_vm.is_edit,
        "accept": "image/*,application/*"
      },
      on: {
        "change": function change(event) {
          return _vm.prefiewFiles(event, state);
        }
      }
    }), !state.file ? _c('label', {
      staticClass: "custom-file-label",
      attrs: {
        "for": "validatedCustomFile"
      }
    }, [_vm._v("Browse file...")]) : _c('label', {
      staticClass: "custom-file-label",
      attrs: {
        "for": "validatedCustomFile"
      }
    }, [_vm._v(_vm._s(state.file_label))])]), state.file_url ? _c('small', {
      staticClass: "text-primary text-right",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenFilePreview(state.file_url);
        }
      }
    }, [_vm._v("Open File ")]) : _vm._e(), _c('br'), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" File Type * : "), _c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File CapaKota * : "), _c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v("10 MB / File")])], 1)])], 1), _vm.user_edit.certificate_of_competency.length > 1 ? _c('div', {
      staticClass: "d-flex w-100 px-2 my-1 border-bottom"
    }) : _vm._e()], 1);
  }), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addCertificateOfCompetencyForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" ADD FORM ")])], 1)], 1)], 2) : _c('div', [_c('b-row', [_c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Nama Dokumen",
      "label-for": "certificate_list_id"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.coc_options,
      "reduce": function reduce(coc_options) {
        return coc_options.value;
      },
      "placeholder": "Select certificate...",
      "name": "certificate_list_id",
      "required": ""
    },
    model: {
      value: _vm.update_certificate_of_competency.certificate_list_id,
      callback: function callback($$v) {
        _vm.$set(_vm.update_certificate_of_competency, "certificate_list_id", $$v);
      },
      expression: "update_certificate_of_competency.certificate_list_id"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Level",
      "label-for": "sub_education"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "required": "",
      "size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": "none"
          }
        }, [_vm._v("Select Options")]), _c('b-form-select-option', {
          attrs: {
            "value": "management"
          }
        }, [_vm._v("Manajemen level")]), _c('b-form-select-option', {
          attrs: {
            "value": "operational"
          }
        }, [_vm._v("Operational level")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.update_certificate_of_competency.sub_education,
      callback: function callback($$v) {
        _vm.$set(_vm.update_certificate_of_competency, "sub_education", $$v);
      },
      expression: "update_certificate_of_competency.sub_education"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "No Dokumen",
      "label-for": "nomor_sertifikat"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nomor_sertifikat",
      "name": "nomor_sertifikat",
      "placeholder": "Type Number ...",
      "required": ""
    },
    model: {
      value: _vm.update_certificate_of_competency.document_number,
      callback: function callback($$v) {
        _vm.$set(_vm.update_certificate_of_competency, "document_number", $$v);
      },
      expression: "update_certificate_of_competency.document_number"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Tanggal Terbit",
      "label-for": "date_issued"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "date_issued",
      "required": ""
    },
    model: {
      value: _vm.update_certificate_of_competency.date_issued,
      callback: function callback($$v) {
        _vm.$set(_vm.update_certificate_of_competency, "date_issued", $$v);
      },
      expression: "update_certificate_of_competency.date_issued"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Tanggal Berakhir",
      "label-for": "masa_berlaku"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "masa_berlaku"
    },
    model: {
      value: _vm.update_certificate_of_competency.validity_period,
      callback: function callback($$v) {
        _vm.$set(_vm.update_certificate_of_competency, "validity_period", $$v);
      },
      expression: "update_certificate_of_competency.validity_period"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Tempat diterbitkan",
      "label-for": "place_issued"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "place_issued",
      "name": "place_issued",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_certificate_of_competency.place_issued,
      callback: function callback($$v) {
        _vm.$set(_vm.update_certificate_of_competency, "place_issued", $$v);
      },
      expression: "update_certificate_of_competency.place_issued"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-12",
    attrs: {
      "label": "Attachment",
      "label-for": "attachment"
    }
  }, [_c('div', {
    staticClass: "custom-file"
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "type": "file",
      "id": "validatedCustomFile",
      "required": !_vm.is_edit
    },
    on: {
      "change": function change(event) {
        return _vm.prefiewFiles(event, _vm.update_certificate_of_competency);
      }
    }
  }), !_vm.update_certificate_of_competency.file ? _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v("Browse file...")]) : _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v(_vm._s(_vm.update_certificate_of_competency.file_label))])]), _c('br'), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" File Type * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File CapaKota * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("10 MB / File")])], 1)])], 1)], 1), _c('b-button', {
    staticClass: "my-3",
    attrs: {
      "disabled": _vm.saving_competency,
      "block": "",
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm.saving_competency ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _c('span', [_vm._v(_vm._s(_vm.is_edit ? 'Update' : 'Tambah') + " Data Certificate of Competency")])])], 1)]), _c('b-modal', {
    attrs: {
      "id": "dokumen_perjalanan",
      "size": "lg",
      "title": _vm.is_edit ? 'Update Data Dokumen Perjalanan' : 'Tambah Data Dokumen Perjalanan',
      "cancel-title": "Close",
      "hide-footer": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": _vm.onSaveTravelDokumen
    }
  }, [!_vm.is_edit ? _c('fieldset', {
    staticClass: "form-group border p-3 mt-1"
  }, [_c('legend', {
    staticClass: "w-auto text-primary",
    staticStyle: {
      "font-size": "12pt"
    }
  }, [_vm._v("TRAVEL DOCUMENT")]), _vm._l(_vm.user_edit.travel_document, function (state, index) {
    return _c('div', {
      key: index
    }, [index > 0 ? _c('div', {
      staticClass: "d-flex w-100 px-1 my-1 justify-content-end cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.deleteTravelDocument(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger"
    })]) : _vm._e(), _c('b-row', [_c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Nama Dokumen"
      }
    }, [_c('b-form-select', {
      attrs: {
        "plain": "",
        "required": "",
        "size": "sm",
        "options": _vm.travel_document_options,
        "name": "document_list_id"
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": ''
            }
          }, [_vm._v("Select Document")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: state.document_list_id,
        callback: function callback($$v) {
          _vm.$set(state, "document_list_id", $$v);
        },
        expression: "state.document_list_id"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Nomor Dokumen",
        "label-for": "nomor_dokumen"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "nomor_dokumen",
        "name": "nomor_dokumen",
        "placeholder": "Type Number ...",
        "required": ""
      },
      model: {
        value: state.document_number,
        callback: function callback($$v) {
          _vm.$set(state, "document_number", $$v);
        },
        expression: "state.document_number"
      }
    })], 1)], 1), _c('b-row', [_c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Date Issued",
        "label-for": "date_issued"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "date",
        "id": "date_issued",
        "required": ""
      },
      model: {
        value: state.date_issued,
        callback: function callback($$v) {
          _vm.$set(state, "date_issued", $$v);
        },
        expression: "state.date_issued"
      }
    }), _c('small', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("click "), _c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" to show ")])], 1), _c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Masa Berlaku",
        "label-for": "masa_berlaku"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "date",
        "id": "masa_berlaku"
      },
      model: {
        value: state.validity_period,
        callback: function callback($$v) {
          _vm.$set(state, "validity_period", $$v);
        },
        expression: "state.validity_period"
      }
    }), _c('small', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("click "), _c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" to show ")])], 1)], 1), _c('b-row', [_c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Place Issued",
        "label-for": "place_issued"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "place_issued",
        "name": "place_issued",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.place_issued,
        callback: function callback($$v) {
          _vm.$set(state, "place_issued", $$v);
        },
        expression: "state.place_issued"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Attachment",
        "label-for": "attachment"
      }
    }, [_c('div', {
      staticClass: "custom-file"
    }, [_c('input', {
      staticClass: "custom-file-input",
      attrs: {
        "type": "file",
        "id": "validatedCustomFile",
        "required": !_vm.is_edit,
        "accept": "image/*,application/*"
      },
      on: {
        "change": function change(event) {
          return _vm.prefiewFiles(event, state);
        }
      }
    }), !state.file ? _c('label', {
      staticClass: "custom-file-label",
      attrs: {
        "for": "validatedCustomFile"
      }
    }, [_vm._v("Browse file...")]) : _c('label', {
      staticClass: "custom-file-label",
      attrs: {
        "for": "validatedCustomFile"
      }
    }, [_vm._v(_vm._s(state.file_label))])]), state.file ? _c('small', {
      staticClass: "text-primary text-right",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenFilePreview(state.file_url);
        }
      }
    }, [_vm._v("Open File")]) : _vm._e(), _c('br'), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" File Type * : "), _c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File CapaKota * : "), _c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v("10 MB / File")])], 1)])], 1), _vm.user_edit.travel_document.length > 1 ? _c('div', {
      staticClass: "d-flex w-100 px-2 my-1 border-bottom"
    }) : _vm._e()], 1);
  }), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addTravelDocumentForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" ADD FORM ")])], 1)], 1)], 2) : _c('div', [_c('b-row', [_c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Nama Dokumen"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "required": "",
      "size": "sm",
      "options": _vm.travel_document_options,
      "name": "document_list_id"
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": ''
          }
        }, [_vm._v("Select Document")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.update_travel_document.document_list_id,
      callback: function callback($$v) {
        _vm.$set(_vm.update_travel_document, "document_list_id", $$v);
      },
      expression: "update_travel_document.document_list_id"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Nomor Dokumen",
      "label-for": "nomor_dokumen"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nomor_dokumen",
      "name": "nomor_dokumen",
      "placeholder": "Type Number ...",
      "required": ""
    },
    model: {
      value: _vm.update_travel_document.document_number,
      callback: function callback($$v) {
        _vm.$set(_vm.update_travel_document, "document_number", $$v);
      },
      expression: "update_travel_document.document_number"
    }
  })], 1)], 1), _c('b-row', [_c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Date Issued",
      "label-for": "date_issued"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "date_issued",
      "required": ""
    },
    model: {
      value: _vm.update_travel_document.date_issued,
      callback: function callback($$v) {
        _vm.$set(_vm.update_travel_document, "date_issued", $$v);
      },
      expression: "update_travel_document.date_issued"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1), _c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Masa Berlaku",
      "label-for": "masa_berlaku"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "masa_berlaku"
    },
    model: {
      value: _vm.update_travel_document.validity_period,
      callback: function callback($$v) {
        _vm.$set(_vm.update_travel_document, "validity_period", $$v);
      },
      expression: "update_travel_document.validity_period"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1)], 1), _c('b-row', [_c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Place Issued",
      "label-for": "place_issued"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "place_issued",
      "name": "place_issued",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_travel_document.place_issued,
      callback: function callback($$v) {
        _vm.$set(_vm.update_travel_document, "place_issued", $$v);
      },
      expression: "update_travel_document.place_issued"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Attachment",
      "label-for": "attachment"
    }
  }, [_c('div', {
    staticClass: "custom-file"
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "type": "file",
      "id": "validatedCustomFile",
      "required": !_vm.is_edit
    },
    on: {
      "change": function change(event) {
        return _vm.prefiewFiles(event, _vm.update_travel_document);
      }
    }
  }), !_vm.update_travel_document.file ? _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v("Browse file...")]) : _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v(_vm._s(_vm.update_travel_document.file_label))])]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" File Type * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File CapaKota * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("10 MB / File")])], 1)])], 1)], 1), _c('b-button', {
    staticClass: "my-3",
    attrs: {
      "disabled": _vm.saving_traveldocument,
      "block": "",
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm.saving_traveldocument ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _c('span', [_vm._v(_vm._s(_vm.is_edit ? 'Update' : 'Tambah') + " Data Travel Document")])])], 1)]), _c('b-modal', {
    attrs: {
      "id": "profesi",
      "size": "lg",
      "title": _vm.is_edit ? 'Update Data Sertifikat Profesi' : 'Tambah Data Sertifikat Profesi',
      "cancel-title": "Close",
      "hide-footer": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": _vm.onSaveProficiency
    }
  }, [!_vm.is_edit ? _c('fieldset', {
    staticClass: "form-group border p-3 mt-1"
  }, [_c('legend', {
    staticClass: "w-auto text-primary",
    staticStyle: {
      "font-size": "12pt"
    }
  }, [_vm._v("CERTIFICATE OF PROFICIENCY")]), _vm._l(_vm.user_edit.certificate_of_proficiency, function (state, index) {
    return _c('div', {
      key: index
    }, [index > 0 ? _c('div', {
      staticClass: "d-flex w-100 px-1 my-1 justify-content-end cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.deleteCertificateOfProfiencyForm(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger"
    })]) : _vm._e(), _c('b-row', [_c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Nama Sertifikat"
      }
    }, [_c('b-form-select', {
      attrs: {
        "plain": "",
        "required": "",
        "size": "sm",
        "options": _vm.cop_options,
        "name": "document_list_id"
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": ''
            }
          }, [_vm._v("Select Certificate")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: state.certificate_list_id,
        callback: function callback($$v) {
          _vm.$set(state, "certificate_list_id", $$v);
        },
        expression: "state.certificate_list_id"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Nomor Dokumen",
        "label-for": "nomor_dokumen"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "nomor_dokumen",
        "name": "nomor_dokumen",
        "placeholder": "Type Number ...",
        "required": ""
      },
      model: {
        value: state.document_number,
        callback: function callback($$v) {
          _vm.$set(state, "document_number", $$v);
        },
        expression: "state.document_number"
      }
    })], 1)], 1), _c('b-row', [_c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Date Issued",
        "label-for": "date_issued"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "date",
        "id": "date_issued",
        "required": ""
      },
      model: {
        value: state.date_issued,
        callback: function callback($$v) {
          _vm.$set(state, "date_issued", $$v);
        },
        expression: "state.date_issued"
      }
    }), _c('small', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("click "), _c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" to show ")])], 1), _c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Masa Berlaku",
        "label-for": "masa_berlaku"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "date",
        "id": "masa_berlaku"
      },
      model: {
        value: state.validity_period,
        callback: function callback($$v) {
          _vm.$set(state, "validity_period", $$v);
        },
        expression: "state.validity_period"
      }
    }), _c('small', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("click "), _c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" to show ")])], 1)], 1), _c('b-row', [_c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Place Issued",
        "label-for": "place_issued"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "place_issued",
        "name": "place_issued",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.place_issued,
        callback: function callback($$v) {
          _vm.$set(state, "place_issued", $$v);
        },
        expression: "state.place_issued"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-6",
      attrs: {
        "label": "Attachment",
        "label-for": "attachment"
      }
    }, [_c('div', {
      staticClass: "custom-file"
    }, [_c('input', {
      staticClass: "custom-file-input",
      attrs: {
        "type": "file",
        "id": "validatedCustomFile",
        "required": !_vm.is_edit,
        "accept": "image/*,application/*"
      },
      on: {
        "change": function change(event) {
          return _vm.prefiewFiles(event, state);
        }
      }
    }), !state.file ? _c('label', {
      staticClass: "custom-file-label",
      attrs: {
        "for": "validatedCustomFile"
      }
    }, [_vm._v("Browse file...")]) : _c('label', {
      staticClass: "custom-file-label",
      attrs: {
        "for": "validatedCustomFile"
      }
    }, [_vm._v(_vm._s(state.file_label))])]), state.file_url ? _c('small', {
      staticClass: "text-primary text-right",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenFilePreview(state.file_url);
        }
      }
    }, [_vm._v("Open File ")]) : _vm._e(), _c('br'), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" File Type * : "), _c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File CapaKota * : "), _c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v("10 MB / File")])], 1)])], 1), _vm.user_edit.certificate_of_proficiency.length > 1 ? _c('div', {
      staticClass: "d-flex w-100 px-2 my-1 border-bottom"
    }) : _vm._e()], 1);
  }), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addCertificateOfProfiencyForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" ADD FORM ")])], 1)], 1)], 2) : _c('div', [_c('b-row', [_c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Nama Sertifikat"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "required": "",
      "size": "sm",
      "options": _vm.cop_options,
      "name": "document_list_id"
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": ''
          }
        }, [_vm._v("Select Certificate")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.update_certificate_of_proficiency.certificate_list_id,
      callback: function callback($$v) {
        _vm.$set(_vm.update_certificate_of_proficiency, "certificate_list_id", $$v);
      },
      expression: "update_certificate_of_proficiency.certificate_list_id"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Nomor Dokumen",
      "label-for": "nomor_dokumen"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nomor_dokumen",
      "name": "nomor_dokumen",
      "placeholder": "Type Number ...",
      "required": ""
    },
    model: {
      value: _vm.update_certificate_of_proficiency.document_number,
      callback: function callback($$v) {
        _vm.$set(_vm.update_certificate_of_proficiency, "document_number", $$v);
      },
      expression: "update_certificate_of_proficiency.document_number"
    }
  })], 1)], 1), _c('b-row', [_c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Date Issued",
      "label-for": "date_issued"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "date_issued",
      "required": ""
    },
    model: {
      value: _vm.update_certificate_of_proficiency.date_issued,
      callback: function callback($$v) {
        _vm.$set(_vm.update_certificate_of_proficiency, "date_issued", $$v);
      },
      expression: "update_certificate_of_proficiency.date_issued"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1), _c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Masa Berlaku",
      "label-for": "masa_berlaku"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "masa_berlaku"
    },
    model: {
      value: _vm.update_certificate_of_proficiency.validity_period,
      callback: function callback($$v) {
        _vm.$set(_vm.update_certificate_of_proficiency, "validity_period", $$v);
      },
      expression: "update_certificate_of_proficiency.validity_period"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1)], 1), _c('b-row', [_c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Place Issued",
      "label-for": "place_issued"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "place_issued",
      "name": "place_issued",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_certificate_of_proficiency.place_issued,
      callback: function callback($$v) {
        _vm.$set(_vm.update_certificate_of_proficiency, "place_issued", $$v);
      },
      expression: "update_certificate_of_proficiency.place_issued"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Attachment",
      "label-for": "attachment"
    }
  }, [_c('div', {
    staticClass: "custom-file"
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "type": "file",
      "id": "validatedCustomFile",
      "required": !_vm.is_edit
    },
    on: {
      "change": function change(event) {
        return _vm.prefiewFiles(event, _vm.update_certificate_of_proficiency);
      }
    }
  }), !_vm.update_certificate_of_proficiency.file ? _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v("Browse file...")]) : _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v(_vm._s(_vm.update_certificate_of_proficiency.file_label))])]), _c('br'), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" File Type * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File CapaKota * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("10 MB / File")])], 1)])], 1)], 1), _c('b-button', {
    staticClass: "my-3",
    attrs: {
      "disabled": _vm.saving_proficiency,
      "block": "",
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm.saving_proficiency ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _c('span', [_vm._v(_vm._s(_vm.is_edit ? 'Update' : 'Tambah') + " Data Certificate of Proficiency")])])], 1)]), _c('b-modal', {
    attrs: {
      "id": "pengalaman_berlayar",
      "size": "lg",
      "title": _vm.is_edit ? 'Update ' : 'Tambah ' + 'Data Pengalaman Berlayar',
      "cancel-title": "Close",
      "hide-footer": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": _vm.onSavePekerjaan
    }
  }, [!_vm.is_edit ? _c('fieldset', {
    staticClass: "form-group border p-3 mt-1"
  }, [_c('legend', {
    staticClass: "w-auto text-primary",
    staticStyle: {
      "font-size": "12pt"
    }
  }, [_vm._v("PENGALAMAN BERLAYAR")]), _vm._l(_vm.user_edit.pekerjaan, function (state, index) {
    return _c('div', {
      key: index
    }, [index > 0 ? _c('div', {
      staticClass: "d-flex w-100 px-1 my-1 justify-content-end cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.deletePekerjaanForm(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger"
    })]) : _vm._e(), _c('b-row', [_c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Nama Perusahaan",
        "label-for": "perusahaan"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "perusahaan",
        "name": "perusahaan",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.perusahaan,
        callback: function callback($$v) {
          _vm.$set(state, "perusahaan", $$v);
        },
        expression: "state.perusahaan"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Lokasi",
        "label-for": "lokasi"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "lokasi",
        "name": "lokasi",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.lokasi,
        callback: function callback($$v) {
          _vm.$set(state, "lokasi", $$v);
        },
        expression: "state.lokasi"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Negara",
        "label-for": "negara"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "negara",
        "name": "negara",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.negara,
        callback: function callback($$v) {
          _vm.$set(state, "negara", $$v);
        },
        expression: "state.negara"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Tahun Masuk",
        "label-for": "tahun_masuk"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "date",
        "id": "tahun_masuk",
        "required": ""
      },
      model: {
        value: state.tahun_masuk,
        callback: function callback($$v) {
          _vm.$set(state, "tahun_masuk", $$v);
        },
        expression: "state.tahun_masuk"
      }
    }), _c('small', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("click "), _c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" to show ")])], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Tahun Keluar",
        "label-for": "tahun_berhenti"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "date",
        "id": "tahun_berhenti",
        "required": ""
      },
      model: {
        value: state.tahun_berhenti,
        callback: function callback($$v) {
          _vm.$set(state, "tahun_berhenti", $$v);
        },
        expression: "state.tahun_berhenti"
      }
    }), _c('small', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("click "), _c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" to show ")])], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Nama Kapal",
        "label-for": "nama_kapal"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "nama_kapal",
        "name": "nama_kapal",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.nama_kapal,
        callback: function callback($$v) {
          _vm.$set(state, "nama_kapal", $$v);
        },
        expression: "state.nama_kapal"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Bendera Kapal",
        "label-for": "bendera_kapal"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "bendera_kapal",
        "name": "bendera_kapal",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.bendera_kapal,
        callback: function callback($$v) {
          _vm.$set(state, "bendera_kapal", $$v);
        },
        expression: "state.bendera_kapal"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Area Operasi",
        "label-for": "area_operasi"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "area_operasi",
        "name": "area_operasi",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.area_operasi,
        callback: function callback($$v) {
          _vm.$set(state, "area_operasi", $$v);
        },
        expression: "state.area_operasi"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Jabatan",
        "label-for": "jabatan"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "jabatan",
        "name": "jabatan",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.jabatan,
        callback: function callback($$v) {
          _vm.$set(state, "jabatan", $$v);
        },
        expression: "state.jabatan"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Gaji",
        "label-for": "gaji"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "id": "gaji",
        "name": "gaji",
        "placeholder": "Type Number ...",
        "required": ""
      },
      model: {
        value: state.gaji,
        callback: function callback($$v) {
          _vm.$set(state, "gaji", $$v);
        },
        expression: "state.gaji"
      }
    }), _c('b-form-text', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(state.gaji)) + " ")])], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Fasilitas",
        "label-for": "fasilitas"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "fasilitas",
        "name": "fasilitas",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.fasilitas,
        callback: function callback($$v) {
          _vm.$set(state, "fasilitas", $$v);
        },
        expression: "state.fasilitas"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Alasan Berhenti",
        "label-for": "alasan_berhenti"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "alasan_berhenti",
        "name": "alasan_berhenti",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.alasan_berhenti,
        callback: function callback($$v) {
          _vm.$set(state, "alasan_berhenti", $$v);
        },
        expression: "state.alasan_berhenti"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Pemberi Rekomendasi",
        "label-for": "pemberi_rekomendasi"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "pemberi_rekomendasi",
        "name": "pemberi_rekomendasi",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.pemberi_rekomendasi,
        callback: function callback($$v) {
          _vm.$set(state, "pemberi_rekomendasi", $$v);
        },
        expression: "state.pemberi_rekomendasi"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "Kontak Pemberi Rekomendasi",
        "label-for": "kontak_pemberi_informasi"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "kontak_pemberi_informasi",
        "name": "kontak_pemberi_informasi",
        "placeholder": "Type Number ...",
        "required": ""
      },
      model: {
        value: state.kontak_pemberi_informasi,
        callback: function callback($$v) {
          _vm.$set(state, "kontak_pemberi_informasi", $$v);
        },
        expression: "state.kontak_pemberi_informasi"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-4",
      attrs: {
        "label": "No. Tlp Perusaahaan",
        "label-for": "no_tlp_perusahaan"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "no_tlp_perusahaan",
        "name": "no_tlp_perusahaan",
        "placeholder": "Type Number ...",
        "required": ""
      },
      model: {
        value: state.no_tlp_perusahaan,
        callback: function callback($$v) {
          _vm.$set(state, "no_tlp_perusahaan", $$v);
        },
        expression: "state.no_tlp_perusahaan"
      }
    })], 1), _c('b-form-group', {
      staticClass: "col-md-12",
      attrs: {
        "label": "Deskripsi Pekerjaan",
        "label-for": "deskripsi_pekerjaan"
      }
    }, [_c('b-form-textarea', {
      attrs: {
        "id": "deskripsi_pekerjaan",
        "name": "deskripsi_pekerjaan",
        "placeholder": "Type Text ...",
        "required": ""
      },
      model: {
        value: state.deskripsi_pekerjaan,
        callback: function callback($$v) {
          _vm.$set(state, "deskripsi_pekerjaan", $$v);
        },
        expression: "state.deskripsi_pekerjaan"
      }
    })], 1)], 1), _vm.user_edit.pekerjaan.length > 1 ? _c('div', {
      staticClass: "d-flex w-100 px-2 my-1 border-bottom"
    }) : _vm._e()], 1);
  }), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addPekerjaanForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" ADD FORM ")])], 1)], 1)], 2) : _c('div', [_c('b-row', [_c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Nama Perusahaan",
      "label-for": "perusahaan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "perusahaan",
      "name": "perusahaan",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.perusahaan,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "perusahaan", $$v);
      },
      expression: "update_pekerjaan.perusahaan"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Lokasi",
      "label-for": "lokasi"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "lokasi",
      "name": "lokasi",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.lokasi,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "lokasi", $$v);
      },
      expression: "update_pekerjaan.lokasi"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Negara",
      "label-for": "negara"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "negara",
      "name": "negara",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.negara,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "negara", $$v);
      },
      expression: "update_pekerjaan.negara"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Tahun Masuk",
      "label-for": "tahun_masuk"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "tahun_masuk",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.tahun_masuk,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "tahun_masuk", $$v);
      },
      expression: "update_pekerjaan.tahun_masuk"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Tahun Keluar",
      "label-for": "tahun_berhenti"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "tahun_berhenti",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.tahun_berhenti,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "tahun_berhenti", $$v);
      },
      expression: "update_pekerjaan.tahun_berhenti"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Nama Kapal",
      "label-for": "nama_kapal"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nama_kapal",
      "name": "nama_kapal",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.nama_kapal,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "nama_kapal", $$v);
      },
      expression: "update_pekerjaan.nama_kapal"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Bendera Kapal",
      "label-for": "bendera_kapal"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "bendera_kapal",
      "name": "bendera_kapal",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.bendera_kapal,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "bendera_kapal", $$v);
      },
      expression: "update_pekerjaan.bendera_kapal"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Area Operasi",
      "label-for": "area_operasi"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "area_operasi",
      "name": "area_operasi",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.area_operasi,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "area_operasi", $$v);
      },
      expression: "update_pekerjaan.area_operasi"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Jabatan",
      "label-for": "jabatan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "jabatan",
      "name": "jabatan",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.jabatan,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "jabatan", $$v);
      },
      expression: "update_pekerjaan.jabatan"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Gaji",
      "label-for": "gaji"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "id": "gaji",
      "name": "gaji",
      "placeholder": "Type Number ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.gaji,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "gaji", $$v);
      },
      expression: "update_pekerjaan.gaji"
    }
  }), _c('b-form-text', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.update_pekerjaan.gaji)) + " ")])], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Fasilitas",
      "label-for": "fasilitas"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "fasilitas",
      "name": "fasilitas",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.fasilitas,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "fasilitas", $$v);
      },
      expression: "update_pekerjaan.fasilitas"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Alasan Berhenti",
      "label-for": "alasan_berhenti"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "alasan_berhenti",
      "name": "alasan_berhenti",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.alasan_berhenti,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "alasan_berhenti", $$v);
      },
      expression: "update_pekerjaan.alasan_berhenti"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Pemberi Rekomendasi",
      "label-for": "pemberi_rekomendasi"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "pemberi_rekomendasi",
      "name": "pemberi_rekomendasi",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.pemberi_rekomendasi,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "pemberi_rekomendasi", $$v);
      },
      expression: "update_pekerjaan.pemberi_rekomendasi"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Kontak Pemberi Rekomendasi",
      "label-for": "kontak_pemberi_informasi"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "kontak_pemberi_informasi",
      "name": "kontak_pemberi_informasi",
      "placeholder": "Type Number ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.kontak_pemberi_informasi,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "kontak_pemberi_informasi", $$v);
      },
      expression: "update_pekerjaan.kontak_pemberi_informasi"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-4",
    attrs: {
      "label": "No. Tlp Perusaahaan",
      "label-for": "no_tlp_perusahaan"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "no_tlp_perusahaan",
      "name": "no_tlp_perusahaan",
      "placeholder": "Type Number ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.no_tlp_perusahaan,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "no_tlp_perusahaan", $$v);
      },
      expression: "update_pekerjaan.no_tlp_perusahaan"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-12",
    attrs: {
      "label": "Deskripsi Pekerjaan",
      "label-for": "deskripsi_pekerjaan"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "deskripsi_pekerjaan",
      "name": "deskripsi_pekerjaan",
      "placeholder": "Type Text ...",
      "required": ""
    },
    model: {
      value: _vm.update_pekerjaan.deskripsi_pekerjaan,
      callback: function callback($$v) {
        _vm.$set(_vm.update_pekerjaan, "deskripsi_pekerjaan", $$v);
      },
      expression: "update_pekerjaan.deskripsi_pekerjaan"
    }
  })], 1)], 1)], 1), _c('b-button', {
    staticClass: "my-3",
    attrs: {
      "disabled": _vm.saving_pekerjaan,
      "block": "",
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm.saving_pekerjaan ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _c('span', [_vm._v(_vm._s(_vm.is_edit ? 'Update' : "Tambah") + " Data Pekerjaan")])])], 1)]), _c('b-modal', {
    attrs: {
      "id": "dokumen_pendukung",
      "size": "lg",
      "title": _vm.is_edit ? 'Update Data Dokumen Pendukung' : 'Tambah Data Dokumen Pendukung',
      "cancel-title": "Close",
      "hide-footer": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": _vm.onSaveDokumenPenting
    }
  }, [!_vm.is_edit ? _c('fieldset', {
    staticClass: "form-group border p-3 mt-1"
  }, [_c('legend', {
    staticClass: "w-auto text-primary",
    staticStyle: {
      "font-size": "12pt"
    }
  }, [_vm._v("DOKUMEN PENDUKUNG")]), _vm._l(_vm.user_edit.support_dokumen, function (state, index) {
    return _c('b-row', {
      key: index
    }, [index > 0 ? _c('div', {
      staticClass: "d-flex w-100 px-1 my-1 justify-content-end cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.deleteSupportdokumen(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger"
    })]) : _vm._e(), _c('b-col', [_c('b-form-group', {
      attrs: {
        "label": "Nama Dokumen",
        "label-for": "nama_dokumen"
      }
    }, [_c('b-form-select', {
      attrs: {
        "plain": "",
        "options": _vm.master_list_document,
        "id": "nama_dokumen",
        "size": "sm",
        "required": ""
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null
            }
          }, [_vm._v("Select Type Document")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: state.document_list_id,
        callback: function callback($$v) {
          _vm.$set(state, "document_list_id", $$v);
        },
        expression: "state.document_list_id"
      }
    })], 1)], 1), _c('b-col', [_c('b-form-group', {
      attrs: {
        "label": "File",
        "label-for": "file"
      }
    }, [_c('div', {
      staticClass: "custom-file"
    }, [_c('input', {
      staticClass: "custom-file-input",
      attrs: {
        "type": "file",
        "id": "validatedCustomFile",
        "accept": "image/x-png,image/jpeg,image/jpg,application/*",
        "required": !_vm.is_edit
      },
      on: {
        "change": function change(event) {
          return _vm.prefiewFiles(event, state);
        }
      }
    }), !state.file ? _c('label', {
      staticClass: "custom-file-label",
      attrs: {
        "for": "validatedCustomFile"
      }
    }, [_vm._v("Browse file...")]) : _c('label', {
      staticClass: "custom-file-label",
      attrs: {
        "for": "validatedCustomFile"
      }
    }, [_vm._v(_vm._s(state.file_label))])]), state.file_url ? _c('small', {
      staticClass: "text-primary text-right",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenFilePreview(state.file_url);
        }
      }
    }, [_vm._v("Open File")]) : _vm._e(), _c('br'), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" File Type * : "), _c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File CapaKota * : "), _c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v("10 MB / File")])], 1)])], 1), _vm.user_edit.support_dokumen.length > 1 ? _c('div', {
      staticClass: "d-flex w-100 px-2 my-1 border-bottom"
    }) : _vm._e()], 1);
  }), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addSupportdokumen
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" ADD FORM")])], 1)], 1)], 2) : _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Nama Dokumen",
      "label-for": "nama_dokumen"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "options": _vm.master_list_document,
      "id": "nama_dokumen",
      "size": "sm",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("Select Type Document")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.update_support_dokumen.document_list_id,
      callback: function callback($$v) {
        _vm.$set(_vm.update_support_dokumen, "document_list_id", $$v);
      },
      expression: "update_support_dokumen.document_list_id"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "File",
      "label-for": "file"
    }
  }, [_c('div', {
    staticClass: "custom-file"
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "type": "file",
      "id": "validatedCustomFile",
      "accept": "image/x-png,image/gif,image/jpeg,application/*",
      "required": !_vm.is_edit
    },
    on: {
      "change": function change(event) {
        return _vm.prefiewFiles(event, _vm.update_support_dokumen);
      }
    }
  }), !_vm.update_support_dokumen.file ? _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v("Browse file...")]) : _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v(_vm._s(_vm.update_support_dokumen.file_label))])]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" File Type * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File CapaKota * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("10 MB / File")])], 1)])], 1)], 1), _c('b-button', {
    staticClass: "my-3",
    attrs: {
      "disabled": _vm.saving_supportdokumen,
      "block": "",
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm.saving_supportdokumen ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _c('span', [_vm._v(_vm._s(_vm.is_edit ? 'Update' : 'Tambah') + " Data Support Document")])])], 1)]), _c('b-modal', {
    attrs: {
      "id": "request-signoff",
      "size": "lg",
      "title": 'Request Sign Off',
      "cancel-title": "Close",
      "hide-footer": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onRequestSignOff.apply(null, arguments);
      }
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3 mt-1"
  }, [_c('legend', {
    staticClass: "w-auto text-primary",
    staticStyle: {
      "font-size": "12pt"
    }
  }, [_vm._v("Form Request Sign Off")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status Crew",
      "label-for": "status_crew"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "options": _vm.optionsEmployeeStatus,
      "size": "sm",
      "required": ""
    },
    on: {
      "change": _vm.changeEmployeeStatus
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("Select Status Crew")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form_request_sign_off.status_emp_crewing_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form_request_sign_off, "status_emp_crewing_id", $$v);
      },
      expression: "form_request_sign_off.status_emp_crewing_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Notice Off",
      "label-for": "notice_off"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "notice_off"
    },
    model: {
      value: _vm.form_request_sign_off.notice_off,
      callback: function callback($$v) {
        _vm.$set(_vm.form_request_sign_off, "notice_off", $$v);
      },
      expression: "form_request_sign_off.notice_off"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Sign Off",
      "label-for": "sign_off"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local",
      "id": "sign_off",
      "required": ""
    },
    model: {
      value: _vm.form_request_sign_off.sign_off,
      callback: function callback($$v) {
        _vm.$set(_vm.form_request_sign_off, "sign_off", $$v);
      },
      expression: "form_request_sign_off.sign_off"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "text-black"
  }, [_vm._v("Reason Sign Off")]), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    attrs: {
      "width": "90%"
    }
  }, [_vm._v("DESKRIPSI")]), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("STATUS")])])]), _c('tbody', _vm._l(_vm.options_reason_signoff, function (state, index) {
    return _c('tr', {
      key: index
    }, [_c('th', [_vm._v(" " + _vm._s(state.name))]), _c('td', {
      staticClass: "text-center"
    }, [[_c('b-form-checkbox', {
      staticClass: "ml-4",
      attrs: {
        "name": "check-button",
        "switch": "",
        "inline": "",
        "disabled": state.disabled
      },
      on: {
        "change": function change($event) {
          return _vm.selectStatusSignOffCrew(state, index, 'request');
        }
      },
      model: {
        value: state.checked,
        callback: function callback($$v) {
          _vm.$set(state, "checked", $$v);
        },
        expression: "state.checked"
      }
    })]], 2)]);
  }), 0)])]), (_vm$options_reason_si3 = _vm.options_reason_signoff) !== null && _vm$options_reason_si3 !== void 0 && (_vm$options_reason_si4 = _vm$options_reason_si3[6]) !== null && _vm$options_reason_si4 !== void 0 && _vm$options_reason_si4.checked ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Reason Blacklist"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "options": _vm.optionBlacklistReasons,
      "size": "lg",
      "aria-placeholder": "Pilih Alasan",
      "required": "",
      "name": "reason_off"
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("Pilih Alasan")])];
      },
      proxy: true
    }], null, false, 4088621210),
    model: {
      value: _vm.form_request_sign_off.reason_blacklist_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form_request_sign_off, "reason_blacklist_id", $$v);
      },
      expression: "form_request_sign_off.reason_blacklist_id"
    }
  })], 1)], 1) : _vm._e(), (_vm$options_reason_si5 = _vm.options_reason_signoff) !== null && _vm$options_reason_si5 !== void 0 && (_vm$options_reason_si6 = _vm$options_reason_si5[6]) !== null && _vm$options_reason_si6 !== void 0 && _vm$options_reason_si6.checked ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remarks"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3",
      "name": "remarks",
      "placeholder": "Notes..."
    },
    model: {
      value: _vm.form_request_sign_off.remarks,
      callback: function callback($$v) {
        _vm.$set(_vm.form_request_sign_off, "remarks", $$v);
      },
      expression: "form_request_sign_off.remarks"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _c('b-button', {
    attrs: {
      "variant": "primary",
      "block": "",
      "type": "submit",
      "disabled": _vm.signoff_loading
    }
  }, [!_vm.signoff_loading ? _c('i', {
    staticClass: "fa fa-save"
  }) : _vm._e(), !_vm.signoff_loading ? _c('span', [_vm._v("SUBMIT")]) : _vm._e(), _vm.signoff_loading ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _vm._e()])], 1)]), _c('b-modal', {
    attrs: {
      "id": "swap-position",
      "size": "lg",
      "title": "Swap",
      "cancel-title": "Close",
      "hide-footer": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": _vm.onSaveSwapPosition
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Vehicles",
      "label-for": "vehicle_id"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.vehicleOptions,
      "reduce": function reduce(vehicleOptions) {
        return vehicleOptions.value;
      },
      "placeholder": "Select Type of Vehicle",
      "required": ""
    },
    model: {
      value: _vm.swap_position.vehicle_id,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_position, "vehicle_id", $$v);
      },
      expression: "swap_position.vehicle_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Join on Board",
      "label-for": "join_on_board"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local",
      "id": "join_on_board",
      "required": ""
    },
    model: {
      value: _vm.swap_position.join_on_board,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_position, "join_on_board", $$v);
      },
      expression: "swap_position.join_on_board"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Sign On",
      "label-for": "start_date"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local",
      "id": "start_date"
    },
    model: {
      value: _vm.swap_position.start_date,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_position, "start_date", $$v);
      },
      expression: "swap_position.start_date"
    }
  }), _c('small', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("click "), _c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" to show ")])], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Company",
      "label-for": "company_id"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "size": "sm",
      "options": _vm.companyOptions,
      "placeholder": "Select options..."
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": ''
          }
        }, [_vm._v("Select Company")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.swap_position.company_id,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_position, "company_id", $$v);
      },
      expression: "swap_position.company_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Port"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.portOptions,
      "reduce": function reduce(portOptions) {
        return portOptions.value;
      },
      "placeholder": "Select port...",
      "required": ""
    },
    model: {
      value: _vm.swap_position.port_id,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_position, "port_id", $$v);
      },
      expression: "swap_position.port_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Position/Jabatan",
      "label-for": "position_id"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "options": _vm.master_list_position,
      "reduce": function reduce(master_list_position) {
        return master_list_position.value;
      },
      "placeholder": "Select Position",
      "required": ""
    },
    model: {
      value: _vm.swap_position.position_id,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_position, "position_id", $$v);
      },
      expression: "swap_position.position_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Attachment",
      "label-for": "attachment"
    }
  }, [_c('div', {
    staticClass: "custom-file"
  }, [_c('input', {
    staticClass: "custom-file-input",
    attrs: {
      "type": "file",
      "id": "validatedCustomFile",
      "accept": "application/*,image/png,image/jpeg,image/jpg"
    },
    on: {
      "change": function change(event) {
        return _vm.prefiewFiles(event, _vm.swap_position);
      }
    }
  }), !_vm.swap_position.file ? _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v("Browse file...")]) : _c('label', {
    staticClass: "custom-file-label",
    attrs: {
      "for": "validatedCustomFile"
    }
  }, [_vm._v(_vm._s(_vm.swap_position.file_label))])]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" File Type * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File CapaKota * : "), _c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("10 MB / File")])], 1)])], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "type": "textarea",
      "label": "Notes",
      "label-for": "remarks"
    }
  }, [_c('b-form-textarea', {
    staticClass: "form-control",
    attrs: {
      "id": "remarks",
      "name": "remarks",
      "rows": "3"
    },
    model: {
      value: _vm.swap_position.remarks,
      callback: function callback($$v) {
        _vm.$set(_vm.swap_position, "remarks", $$v);
      },
      expression: "swap_position.remarks"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": '6'
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Close")])], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "block": "",
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [!_vm.saving ? _c('i', {
    staticClass: "fa fa-edit"
  }) : _vm._e(), !_vm.saving ? _c('span', [_vm._v("SUBMIT")]) : _vm._e(), _vm.saving ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _vm._e()])], 1)], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }